var descriptionData = {
    "tags":[
        {
            "name":"assignments",
            "description":"Management of ISPW assignments"
        },
        {
            "name":"build",
            "description":"Management of ISPW builds"
        },
        {
            "name":"componentVersions",
            "description":"Management of ISPW component versions"
        },
        {
            "name":"containers",
            "description":"Management of ISPW containers"
        },
        {
            "name":"deployments",
            "description":"Management of ISPW deployments"
        },
        {
        	"name":"commits",
        	"description": "Management of tasks synchronized through the Git to ISPW integration"
        },
        {
        	"name":"promotionAnalysis",
        	"description": "Analysis of ISPW promotion-worthiness"
        },
        {
            "name":"releases",
            "description":"Management of ISPW releases"
        },
        {
            "name":"sets",
            "description":"Management of ISPW sets"
        },
        {
            "name":"webhooks",
            "description":"Management of webhooks"
        },
        {
            "name":"workList",
            "description":"Management of ISPW work lists"
        }
    ],
    "paths":{
        "/webhooks":{
            "put":{
                "summary":"Modify a webhook.",
                "parameters":[
                    {
                        "name":"body",
                        "description":"The data used to modify a webhook"
                    }
                ]
            },
            "post":{
                "summary":"Create a webhook",
                "parameters":[
                    {
                        "name":"body",
                        "description":"The data used to create a webhook"
                    }
                ]
            }
        },
        "/{srid}/assignments":{
            "post":{
                "summary":"Create an assignment.",
                "description": "<h4>Example: Create an assignment for stream \"FOO\", application \"BAR\", with the assignment prefix \"FB1\"</h4>\n<pre class=\'example\'>json body:\n{\n   \"stream\":\"FOO\",\n    \"application\":\"BAR\",\n    \"defaultPath\":\"DEV1\",\n    \"description\":\"assignment for foobar\",\n    \"assignmentPrefix\":\"FB1\"\n}\n\ncurl -v -XPOST -H \'Authorization: c61f932e-2a08-4c6f-bf8f-984ee67f9e32\' -H \'Content-type: application/json\' -d \"$json\" \'http://cesLocation:48226/ispw/w3t/assignments/\'\n</pre><h4>Example: 201 Response</h4><pre>{\n    \"assignmentId\": \"ISPW100025\",\n    \"url\": \"http:\/\/cesLocation.com:48226\/ispw\/w3t\/assignments\/FB000001\"\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"body",
                        "description":"The data used to create an assignment"
                    }
                ],
                "responses": {
                	"201": {
                		"description": "Created - this code indicates that the request to create an assignment completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"500": {
                		"description": "Error - the prefix is not one which is defined to the system. Use a defined prefix and try again. If you do not know the defined prefixes, contact your ISPW Administrator for assistance."
                	}
                }
            }
        },
        "/{srid}/assignments/{assignmentId}/tasks/build":{
            "post":{
            	"summary":"Build an assignment. The valid SetInfo fields are runtimeConfiguration, changeType, events, and execStat.",
            	"description":"<h4>Example: Build tasks at level \"DEV1\" in assignment \"PLAY000084\"</h4>\n<pre>curl --request POST \n  --url \'http://cesLocation:48226/ispw/assignments/PLAY000084/tasks/build?level=DEV1\' \n  --header \'authorization: 0148da8e-a20a-4510-9005-b6daafb443c1\' \n  --header \'content-type: application/json\' \n  --data \'{\n	\"runtimeConfiguration\" : \"FOOBAR\"\n}\'</pre>\n<h4>Example: 200 Response</h4>\n<pre>{\n  \"setId\": \"S000001037\",\n  \"assignmentId\": \"PLAY000083\",\n  \"url\": \"http://cesLocation:48226/ispw/sets/S000001037\",\n  \"tasks\": [\n    {\n      \"application\": \"PLAY\",\n      \"currentLevel\": \"DEV1\",\n      \"moduleName\": \"TPROG05\",\n      \"moduleType\": \"COB\",\n      \"stream\": \" \",\n      \"taskId\": \"7E3814D6B9FA\"\n    },\n    {\n      \"application\": \"PLAY\",\n      \"currentLevel\": \"DEV1\",\n      \"moduleName\": \"TSUBR05\",\n      \"moduleType\": \"COB\",\n      \"stream\": \" \",\n      \"taskId\": \"7E3814DF2ECC\"\n    }\n  ]\n}\n</pre>\n<br><br>",
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"assignmentId",
                        "in":"path",
                        "required":true,
                        "description":"The ID of the assignment to build."
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true,
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true,
                        "description":"Tasks in the assignment at this level will be built."
                    },
                    {
                        "type":"string",
                        "name":"mname",
                        "in":"query",
                        "required":false,
                        "description":"Components with this name in the assignment will be built, if specified."
                    },
                    {
                        "type":"string",
                        "name":"mtype",
                        "in":"query",
                        "required":false,
                        "description":"Component of this type in the assignment will be built, if specified."
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "description":"The data used to perform a build.",
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"Build Initiated - the build has been started.",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/BuildResponse"
                        }
                    },
                    "400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"409": {
                		"description": "Conflict - a referenced entity could not be found or caused a conflict."
                	},
                	"500": {
                		"description": "Server Error - An error occurred while attempting to login to ISPW."
                	}
                },
                "tags":[
                    "assignments"
                ]
            }
        },
        "/{srid}/assignments/{assignmentid}/cancel":{
            "post":{
                "summary":"Cancel an assignment. The valid SetInfo fields are runtimeConfiguration, events, httpHeaders and credentials.",
                "description": "<h4>Example: Cancel an assignment \"ASSIGN123\"</h4>\n<pre class=\'example\'>json body:\n{\n  \"runtimeConfiguration\" : \"FOOBAR\"\n}\n</pre><h4>Example: 201 Response</h4><pre>{\n\t\"assignmentId\": \"ASSIGN123\",\n\t\"url\": \"http://cesLocation.com:48226/ispw/w3t/assignments/ASSIGN123/cancel\"\n}</pre><br><br>",
                "parameters":[
                    {
                        "type":"string",
                        "name":"assignmentid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                	"201": {
                		"description": "Canceled - this code indicates that the request to cancel an assignment completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON Response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"500": {
                		"description": "Error - the Prefix is not one which is defined to the system. Use a defined Prefix and try again. If you do not know the defined Prefixes, contact your ISPW Administrator for assistance."
                	}
                }
            }
        },
        "/{srid}/assignments/{assignmentid}/close":{
            "post":{
                "summary":"Close an assignment. The valid SetInfo fields are runtimeConfiguration, events, httpHeaders and credentials.",
                "description": "<h4>Example: close an assignment \"ASSIGN123\"</h4>\n<pre class=\'example\'>json body:\n{\n  \"runtimeConfiguration\" : \"FOOBAR\"\n}\n</pre><h4>Example: 201 Response</h4><pre>{\n\t\"assignmentId\": \"ASSIGN123\",\n\t\"url\": \"http://cesLocation.com:48226/ispw/w3t/assignments/ASSIGN123/close\"\n}</pre><br><br>",
                "parameters":[
                    {
                        "type":"string",
                        "name":"assignmentid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                	"201": {
                		"description": "Closed - this code indicates that the request to close an assignment completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"500": {
                		"description": "Error - the Prefix is not one which is defined to the system. Use a defined Prefix and try again. If you do not know the defined Prefixes, contact your ISPW Administrator for assistance."
                	}
                }
            }
        },
        "/{srid}/assignments/{assignmentId}/task/add":{ 
            "post":{
                "summary":"Add a task with an optional checkout to an assignment.",
                  "description":"<h4>Example: Create a task \"TPROG01\" in an assignment \"PLAY000333\"<h4>\n<pre>curl --request POST \\\r\n  --url 'http:\/\/cesLocation:48226\/ispw\/connectionName\/assignments\/PLAY000333\/task\/add?checkout=true' \\\r\n  --header 'authorization: 91a8423f-0ca1-47d1-bb6f-12b25b689e47' \\\r\n  --header 'content-type: application\/json' \\\r\n  --data '{\r\n\t  \"runtimeConfiguration\":\"FOOBAR\",\r\n\t  \"taskName\" : \"TPROG01\",\r\n    \"stream\": \"PLAY\",\r\n    \"application\": \"PLAY\",\r\n\t  \"type\" : \"COB\",\r\n\t  \"path\": \"DEV1\",\r\n\t  \"owner\": \"FOOUSER\",\r\n\t  \"releaseId\" : \"REL000333\",\r\n\t  \"checkoutFromLevel\": \"PRD\"\r\n}'</pre><h4>Example: 200 Response</h4><pre>{\r\n    \"message\": \"Task TPROG01 was successfully added and checked out to PLAY000333\",\r\n\t\"setId\": \"S000000001\",\r\n\t\"taskName\": \"TPROG01\",\r\n\t\"url\": \"http:\\\/\\\/cesLocation:48226\\\/ispw\\\/connectionName\\\/assignments\\\/PLAY000333\\\/task\\\/TPROG01\"\r\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"assignmentId",
                        "description":"The ID of the assignment container you intend to add the task to."
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"checkout",
                        "description":"Whether to checkout the task.  Valid values are true or false.  Defaut value is false." 
                    },
                    {
                        "name":"body",
                        "description":"The data used to create the task in the assignment."
                    }
                ],
                "responses": {
                	"200": {
                		"description": "Success - this code indicates that the request to add and/or checkout a task to an assignment completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"409": {
                		"description": "Conflict - a referenced entity could not be found or caused a conflict."
                	},
                	"500": {
                		"description": "Server Error - An error occurred while attempting to login to ISPW."
                	}
                }
            }
        },
        "/{srid}/assignments/{assignmentId}/tasks/deploy":{
            "post":{
                "summary":"Deploy an assignment. The valid DeployInfo fields are all fields except for taskId.",
                "description":"<h4>Example: Deploy \"FOO\" from level \"qa\". On success, POST notification to Slack.</h4>\n<pre>json body:\n{\n    \"runtimeConfiguration\": \"FOOBAR\",\n    \"events\": [{\n        \"name\": \"complete\",\n        \"url\":\"https:\/\/hooks.slack.com\/services\/lkj3hul3\/jhadsi8yasd\/li8asij2d90jmnas\",\n        \"body\": {\"text\": \"FOO promoted from qa!\"\n        }\n    }]\n}\n\ncurl -XPOST -H \'Authorization: 097548e7-fc41-479d-ad89-fe9c61466ea9\'  -H \'Content-type: application/json\' -d \"$json\" \'http://cesLocation:48226/ispw/w3t/assignments/FOO/tasks/deploy?level=qa\'\n</pre><h4>Example: 201 Response</h4><pre>{\n    \"setId\":\"ISPW2345\",\n    \"message:\"\",\n    \"url\":\"http://cesLocation:48226/ispw/w3t/sets/s0123456\" // URL to GET Set\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"assignmentId",
                        "description":"The ID of the assignment you intend to deploy."
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"level",
                        "description":"Tasks in the assignment at this level will be deployed."
                    },
                    {
                        "name":"mname",
                        "description":"Components with this name in the assignment will be deployed if specified."
                    },
                    {
                        "name":"mtype",
                        "description":"Components of this type in the assignment will be deployed if specified."
                    },
                    {
                        "name":"body",
                        "description":"The data used to deploy the tasks in the assignment"
                    }
                ],
                "responses": {
                	"201": {
                		"description": "Promoted - this code indicates that the request to deploy an assignment completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	}
                }
            }
        },
        "/{srid}/assignments/{assignmentId}/taskIds/deploy":{ 
            "post":{
                "summary":"Deploys tasks in an assignment. You may use task IDs to deploy specific tasks in that assignment. The valid DeployInfo fields are all fields.",
                  "description":"<h4>Example: Deploy tasks with multiple task IDs \"7E382B6270DC\" \"7E3AEB250B94\" at level DEV1 in an assignment \"PLAY000333\"</h4>\n<pre>curl --request POST \n  --url \'http://cesLocation:48226/ispw/assignments/PLAY000333/taskIds/deploy?level=DEV1&taskId=7E382B6270DC&taskId=7E3AEB250B94\' \n  --header \'authorization: 0148da8e-a20a-4510-9005-b6daafb443c1\' \n  --header \'content-type: application/json\' \n  --data \'{\n	\"runtimeConfiguration\" : \"FOOBAR\"\n	\"events\": [{\n        \"name\": \"complete\",\n        \"url\":\"https://hooks.slack.com/services/lkj3hul3/jhadsi8yasd/li8asij2d90jmnas\",\n        \"body\":\n        {\n            \"text\": \"FOO deployed from DEV1!\"\n        }\n    }]\n}\'</pre>\n<h4>Example: 200 Response</h4>\n<pre>{\n  \"setId\": \"S000001048\",\n  \"message\": \"\",\n  \"url\": \"http://cesLocation:48226/ispw/sets/S000001048\"\n}\n</pre>\n<br><br>",
                "parameters":[
                    {
                        "type":"string",
                        "name":"assignmentId",
                        "in":"path",
                        "required":true,
                        "description":"The ID of the assignment the tasks reside in."
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true,
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true,
                        "description":"A task at this level will be deployed."
                    },
                    {
                        "type":"string",
                        "name":"taskId",
                        "in":"query",
                        "required":false,
                        "description":"A task with this task ID will be deployed."
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "description":"The data used to perform a deployment.",
                        "schema":{
                            "$ref":"#/definitions/DeployInfo"
                        }
                    }
                ],
                "responses": {
                	"200": {
                		"description": "Deployed - this code indicates that the request to deploy in an assignment with task IDs completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"409": {
                		"description": "Conflict - a referenced entity could not be found or caused a conflict."
                	},
                	"500": {
                		"description": "Server Error - An error occurred while attempting to login to ISPW."
                	}
                }
            }
        },
        "/{srid}/assignments/{assignmentId}/tasks/fallback":{
            "post":{
                "summary":"Fallback an assignment.",
                "description": "<h4>Example: Fallback \"FOO\" from level \"qa\". On success, POST notification to Slack.</h4>\n<pre>json body:\n{\n   \"runtimeConfiguration\": \"FOOBAR\",\n    \"events\": [{\n        \"name\": \"complete\",\n        \"url\":\"https://hooks.slack.com/services/lkj3hul3/jhadsi8yasd/li8asij2d90jmnas\",\n        \"body\":\n        {\n           \"text\": \"FOO fallback from qa!\"\n        }\n    }]\n}\n\ncurl -XPOST -H \'Authorization: 097548e7-fc41-479d-ad89-fe9c61466ea9\'  -H \'Content-type: application/json\' -d \"$json\" \'http://cesLocation:48226/ispw/w3t/assignments/FOO/tasks/fallback?level=qa\'</pre><h4>Example: 201 Response</h4>\n<pre>{\n    \"setId\":\"ISPW2345\",\n    \"message:\"\",\n    \"url\":\"http://cesLocation:48226/ispw/w3t/sets/s0123456\" // URL to GET Set\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"assignmentId",
                        "description":"The ID of the assignment that you want information on."
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"level",
                        "description":"Tasks in the assignment at this level will fallback."
                    },
                    {
                        "name":"mname",
                        "description":"Components with this name in the assignment will fallback if specified."
                    },
                    {
                        "name":"mtype",
                        "description":"Component of this type in the assignment will fallback if specified."
                    },
                    {
                        "name":"body",
                        "description":"The data used to perform a fallback"
                    }
                ],
                "responses": {
                	"201": {
                		"description": "Fallback - this code indicates that the request to promote an assignment completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	}
                }
            }
        },
        "/{srid}/assignments/{assignmentId}/tasks/generate":{
            "post":{
                "summary":"Generate tasks in an assignment. The valid SetInfo fields are runtimeConfiguration, autoDeploy, changeType, executionStatus, httpHeaders, credentials and events.",
                "description":"<h4>Example: Generate tasks at level \"qa\" in assignment \"FB000001\"</h4>\n<pre>json body:\n{\n    \"runtimeConfiguration\": \"FOOBAR\",\n    \"events\": [{\n        \"name\": \"complete\",\n        \"url\":\"https://hooks.slack.com/services/lkj3hul3/jhadsi8yasd/li8asij2d90jmnas\",\n        \"body\":\n        {\n            \"text\": \"FOO generated from qa!\"\n        }\n    }]\n}\n\ncurl -XPOST -H \'Authorization: 097548e7-fc41-479d-ad89-fe9c61466ea9\'  -H \'Content-type: application/json\' -d \"$json\" \'http://cesLocation:48226/ispw/w3t/assignments/FB000001/tasks/generate?level=qa\'\n</pre><h4>Example: 201 Response</h4><pre>{\n    \"setId\":\"ISPW2345\",\n    \"message:\"\",\n    \"url\":\"http://cesLocation:48226/ispw/w3t/sets/s0123456\" // URL to GET Set\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"assignmentId",
                        "description":"The ID of the assignment for which you intend to generate tasks."
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"level",
                        "description":"Tasks in the assignment at this level will be generated."
                    },
                    {
                        "name":"mname",
                        "description":"Components with this name in the assignment will be generated if specified."
                    },
                    {
                        "name":"mtype",
                        "description":"Components of this type in the assignment will be generated if specified."
                    },
                    {
                        "name":"body",
                        "description":"The data used to perform a generate."
                    }
                ],
                "responses": {
                	"201": {
                		"description": "Generated - this code indicates that the request to generate in an assignment completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	}
                }
            }
        },
        "/{srid}/assignments/{assignmentId}/taskIds/generate":{ 
            "post":{
                "summary":"Generates tasks in an assignment. You may use task IDs to generate specific tasks in that assignment. The valid SetInfo fields are runtimeConfiguration, autoDeploy, taskId, changeType, events, and execStat.",
                  "description":"<h4>Example: Generate task with multiple task IDs \"7E382B6270DC\" \"7E3AEB250B94\" at level DEV1 in an assignment \"PLAY000333\"</h4>\n<pre>curl --request POST \n  --url \'http://cesLocation:48226/ispw/assignments/PLAY000333/taskIds/generate?level=DEV1&taskId=7E382B6270DC&taskId=7E3AEB250B94\' \n  --header \'authorization: 0148da8e-a20a-4510-9005-b6daafb443c1\' \n  --header \'content-type: application/json\' \n  --data \'{\n	\"runtimeConfiguration\" : \"FOOBAR\"\n	\"events\": [{\n        \"name\": \"complete\",\n        \"url\":\"https://hooks.slack.com/services/lkj3hul3/jhadsi8yasd/li8asij2d90jmnas\",\n        \"body\":\n        {\n            \"text\": \"FOO generated from DEV1!\"\n        }\n    }]\n}\'</pre>\n<h4>Example: 200 Response</h4>\n<pre>{\n  \"setId\": \"S000001048\",\n  \"message\": \"\",\n  \"url\": \"http://cesLocation:48226/ispw/sets/S000001048\"\n}\n</pre>\n<br><br>",
                "parameters":[
                    {
                        "type":"string",
                        "name":"assignmentId",
                        "in":"path",
                        "required":true,
                        "description":"The ID of the assignment the tasks reside in."
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true,
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true,
                        "description":"A task at this level will be generated."
                    },
                    {
                        "type":"string",
                        "name":"taskId",
                        "in":"query",
                        "required":false,
                        "description":"A task with this task ID will be generated."
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "description":"The data used to perform a generate.",
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses": {
                	"200": {
                		"description": "Generated - this code indicates that the request to generate in an assignment with task IDs completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"409": {
                		"description": "Conflict - a referenced entity could not be found or caused a conflict."
                	},
                	"500": {
                		"description": "Server Error - An error occurred while attempting to login to ISPW."
                	}
                }
            }
        },
        "/{srid}/assignments/{assignmentId}/tasks/promote":{
            "post":{
                "summary":"Promote an assignment.",
                "description": "<h4>Example: Promote \"FOO\" from level \"qa\". On success, POST notification to Slack.</h4>\n<pre>json body:\n{\n   \"runtimeConfiguration\": \"FOOBAR\",\n    \"events\": [{\n        \"name\": \"complete\",\n        \"url\":\"https://hooks.slack.com/services/lkj3hul3/jhadsi8yasd/li8asij2d90jmnas\",\n        \"body\":\n        {\n           \"text\": \"FOO promoted from qa!\"\n        }\n    }]\n}\n\ncurl -XPOST -H \'Authorization: 097548e7-fc41-479d-ad89-fe9c61466ea9\'  -H \'Content-type: application/json\' -d \"$json\" \'http://cesLocation:48226/ispw/w3t/assignments/FOO/tasks/promote?level=qa\'</pre><h4>Example: 201 Response</h4>\n<pre>{\n    \"setId\":\"ISPW2345\",\n    \"message:\"\",\n    \"url\":\"http://cesLocation:48226/ispw/w3t/sets/s0123456\" // URL to GET Set\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"assignmentId",
                        "description":"The ID of the assignment that you want information on."
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"level",
                        "description":"Tasks in the assignment at this level will be promoted."
                    },
                    {
                        "name":"mname",
                        "description":"Components with this name in the assignment will be promoted if specified."
                    },
                    {
                        "name":"mtype",
                        "description":"Component of this type in the assignment will be promoted if specified."
                    },
                    {
                        "name":"body",
                        "description":"The data used to perform a promote"
                    }
                ],
                "responses": {
                	"201": {
                		"description": "Generated - this code indicates that the request to promote an assignment completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	}
                }
            }
        },
        "/{srid}/assignments/{assignmentId}/tasks/promotionAnalysis":{
            "post":{
            "summary":"Run promotion analysis on an Assignment. Checks whether all the tasks in the assignment are ready to be promoted.",
            "description":"<h4>Example: Promotion Analysis of tasks in assignment \"PLAY000084\"</h4>\n<pre>curl --request POST \n  --url \'http://cesLocation:48226/ispw/w3t/assignments/PLAY000084/tasks/promotionAnalysis\' \n  --header \'authorization: 0148da8e-a20a-4510-9005-b6daafb443c1\' \n  --header \'content-type: application/json\' \n  --data \'{\n	\"runtimeConfiguration\" : \"FOOBAR\"\n}\'</pre>\n<h4>Example: 200 Response</h4>\n<pre>{\n  \"numberOfErrors\": 1,\n  \"numberOfWarnings\": 0,\n  \"numberOfInfos\": 1,\n  \"timeOfAnalysis\": \"Wed Jan 15 15:27\",\n  \"containerId\": \"PLAY000084\",\n  \"numberOfTasksAnalyzed\": 2\n}\n</pre>\n<br><br>",
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"assignmentId",
                        "in":"path",
                        "required":true,
                        "description":"The ID of the assignment to analyze."
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true,
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                    	"description":"Promotion Analysis completed successfully",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/PromotionAnalysisResponse"
                        }
                    },
                    "400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"409": {
                		"description": "Conflict - a referenced entity could not be found or caused a conflict."
                	},
                	"500": {
                		"description": "Server Error - An error occurred while attempting to login to ISPW."
                	}
                },
                "tags":[
                    "assignments"
                ]
            }
        },
        "/{srid}/assignments/{assignmentId}/tasks/regress":{
            "post":{
                "summary":"Regress an assignment. The valid SetInfo fields are runtimeConfiguration, changeType, executionStatus, httpHeaders, credentials and events.",
                "description": "<h4>Example: Regress \"FOO\" from level \"qa\". On success, POST notification to Slack.</h4>\n<pre>json body:\n{\n    \"runtimeConfiguration\": \"FOOBAR\",\n    \"events\": [{\n        \"name\": \"complete\",\n        \"url\":\"https://hooks.slack.com/services/lkj3hul3/jhadsi8yasd/li8asij2d90jmnas\",\n        \"body\": {\"text\": \"FOO regressed from qa!\"}\n    }]\n}\n\ncurl -XPOST -H \'Authorization: 097548e7-fc41-479d-ad89-fe9c61466ea9\'  -H \'Content-type: application/json\' -d \"$json\" \'http://cesLocation.com/ispw/w3t/assignments/FOO/tasks/regress?level=qa\'</pre><h4>Example: 201 Response</h4>\n<pre>{\n    \"setId\":\"ISPW2345\",\n   \"message:\"\",\n    \"url\":\"http://cesLocation.com/ispw/w3t/sets/s0123456\" // URL to GET Set\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"assignmentId",
                        "description":"The ID of the assignment you intend to regress."
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"level",
                        "description":"Tasks in the assignment at this level will be regressed."
                    },
                    {
                        "name":"mname",
                        "description":"Components with this name in the assignment will be regressed if specified."
                    },
                    {
                        "name":"mtype",
                        "description":"Components of this type in the assignment will be regressed if specified."
                    },
                    {
                        "name":"body",
                        "description":"The data used to perform a regression"
                    }
                ],
                "responses": {
                	"201": {
                		"description": "Regressed - this code indicates that the request to regress a release completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	}
                }
            }
        },
        "/{srid}/assignments/{assignmentid}":{
            "get":{
                "summary":"Get information about the assignment.",
                "description":"<h4>Example: Get information about assignment \"FB000001\"<h4>\n<pre>curl -XGET -H \'Authorization: 097548e7-fc41-479d-ad89-fe9c61466ea9\' -H \'Content-type: application/json\' \'http://cesLocation:48226/ispw/w3t/assignments/FB000001\'</pre><h4>Example: 200 Response</h4>\n<pre>{\n    \"application\": \"FOO\",\n    \"defaultPath\": \"DEV1\",\n    \"description\": \"ASSIGNMENT FOR FOOBAR\",\n    \"owner\": \"FOOUSR\",\n    \"assignmentId\": \"FB000001\",\n    \"refNumber\": \"1234\",\n    \"release\": \"REL1\",\n    \"stream\": \"BAR\",\n    \"userTag\": \"USRTAG\"\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"assignmentid",
                        "description":"The ID of the assignment that you want information on."
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    }
                ],
                "responses": {
                	"200": {
                		"description": "Success - this code indicates that the request completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"405": {
                		"description": "Error - this call requires a Get. Confirm that a Get was used."
                	}
                }
            }
        },
        "/{srid}/assignments/{assignmentid}/tasks":{
            "get":{
                "summary":"List tasks in the specified assignment.",
                "description": "<h4>Example: Get task list for assignment \"FOO1000019\"<h4>\n<pre>curl -XGET -H \'Authorization: 097548e7-fc41-479d-ad89-fe9c61466ea9\' -H \'Content-type: application/json\' \'http://cesLocation:48226/ispw/w3t/assignments/FOO1000019/tasks\'</pre><h4>Example: 200 Response</h4>\n<pre>{\n    \"tasks\": [\n    {\n        \"action\": \" \",\n        \"alternateName\": \" \",\n        \"application\": \"FOO\",\n        \"container\": \"F001000019\",\n        \"baseVersion\": 0,\n        \"cics\": false,\n        \"clazz\": \" \",\n        \"dateTime\": \"2017-09-01 10:51:24\",\n        \"environment\": \"TEST\",\n        \"extension\": \" \",\n        \"flags\": \"Y\",\n        \"ims\": false,\n        \"internalVersion\": 0,\n        \"level\": \"DEV1\",\n        \"message\": \"OK\",\n        \"operation\": \"G\",\n        \"path\": \"DEV1\",\n        \"program\": true,\n        \"release\": \"REL1\",\n        \"replaceVersion\": 0,\n        \"set\": \" \",\n        \"sql\": false,\n        \"status\": \" \",\n        \"stream\": \"BAR\",\n        \"taskId\": \"7E12E3B57A02\",\n        \"type\": \"COB\",\n        \"userId\": \"FOOUSER\",\n        \"version\": 0,\n        \"memberName\": \"COBGOOD1\"\n    },\n    {\n        \"action\": \" \",\n        \"alternateName\": \" \",\n        \"application\": \"FOO\",\n        \"container\": \"FB00001\",\n        \"baseVersion\": 0,\n        \"cics\": false,\n        \"clazz\": \" \",\n        \"dateTime\": \"2017-09-01 10:51:24\",\n        \"environment\": \"TEST\",\n        \"extension\": \" \",\n        \"flags\": \"Y\",\n        \"ims\": false,\n        \"internalVersion\": 0,\n        \"level\": \"DEV1\",\n        \"message\": \"OK\",\n        \"operation\": \"G\",\n        \"path\": \"DEV1\",\n        \"program\": true,\n        \"release\": \"REL1\",\n        \"replaceVersion\": 0,\n        \"set\": \" \",\n        \"sql\": false,\n        \"status\": \" \",\n        \"stream\": \"BAR\",\n        \"taskId\": \"7E12E3B59441\",\n        \"type\": \"COB\",\n        \"userId\": \"FOOUSER\",\n        \"version\": 0,\n        \"memberName\": \"COBGOOD2\"\n    }\n  ]\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"assignmentid",
                        "description":"The ID of the assignment you want information on."
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"level",
                        "description":"All tasks in the release at this level will be displayed."
                    }
                ],
                "responses": {
                	"200": {
                		"description": "Success - this code indicates that the request completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"405": {
                		"description": "Error - this call requires a Get. Confirm that a Get was used."
                	}
                }
            },
            "post":{
                "summary":"Load a task. The valid TaskInfo fields are application, stream, moduleName, moduleType, userId, currentLevel, startingLevel, container, program, generateSequence, sql, ims, cics, option1, option2, option3, option4 and option5.",
                "description":"<h4>Example: Create an assignment for application \"APP1\", stream \"STRM1\", with the ID \"MEMBER1\"</h4>\n<pre>json body:\n{\n    \"application\": \"APP1\",\n    \"moduleName\": \"MEMBER1\",\n    \"moduleType\": \"JCL\",\n    \"stream\":\"STRM1\",\n    \"currentLevel\": \"STG1\",\n    \"startingLevel\": \"DEV1\"\n}</pre><h4>Example: 201 Response</h4>\n<pre>{\n    \"assignmentId\":\"ISPW2345\",\n    \"message:\"\",\n    \"url\":\"http://cesLocation:48226/ispw/w3t/releases/ISPW2345\"\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"assignmentid",
                        "description":" The assignment ID."
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"body",
                        "description":"The data used to perform a task load."
                    }
                ],
                "responses": {
                	"201": {
                		"description": "Created - this code indicates that the request to load a task completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	}
                }
            }
        },
        "/{srid}/assignments/{assignmentid}/tasks/{taskid}":{
            "get":{
                "summary":"Get information about the task in the specified assignment.",
                "description":"<h4>Example: Get information about assignment \"FB000001\"</h4>\n<pre>curl -XGET -H \'Authorization: 097548e7-fc41-479d-ad89-fe9c61466ea9\' -H \'Content-type: application/json\' \'http://cesLocation:48226/ispw/w3t/assignments/FB000001/tasks/7E12E3B57A02\'</pre><h4>Example: 200 Response</h4>\n<pre>{\n        \"action\": \" \",\n        \"alternateName\": \" \",\n        \"application\": \"FOO\",\n        \"container\": \"F001000019\",\n        \"baseVersion\": 0,\n        \"cics\": false,\n        \"clazz\": \" \",\n        \"dateTime\": \"2017-09-01 10:51:24\",\n        \"environment\": \"TEST\",\n        \"extension\": \" \",\n        \"flags\": \"Y\",\n        \"ims\": false,\n        \"internalVersion\": 0,\n        \"level\": \"DEV1\",\n        \"message\": \"OK\",\n        \"operation\": \"G\",\n        \"path\": \"DEV1\",\n        \"program\": true,\n        \"release\": \"REL1\",\n        \"replaceVersion\": 0,\n        \"set\": \" \",\n        \"sql\": false,\n        \"status\": \" \",\n        \"stream\": \"BAR\",\n        \"taskId\": \"7E12E3B57A02\",\n        \"type\": \"COB\",\n        \"userId\": \"FOOUSER\",\n        \"version\": 0,\n        \"memberName\": \"COBGOOD1\"\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"assignmentid",
                        "description":"The ID of the assignment you want information on."
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"taskid",
                        "description":" The ID of the task you want a listing for."
                    }
                ],
                "responses": {
                	"200": {
                		"description": "Success - this code indicates that the request completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"405": {
                		"description": "Error - this call requires a Get. Confirm that a Get was used."
                	}
                }
            }
        },
        "/{srid}/assignments/{assignmentid}/tasks/{taskid}/listing":{
            "get":{
                "summary":"Get an assignment task generate listing",
                "description": "<h4>Example: Get task generate listing for assignment \"FB001000019\" task id \"73188CE31055\"</h4>\n<pre>curl -XGET -H \'Authorization: 097548e7-fc41-479d-ad89-fe9c61466ea9\' -H \'Content-type: application/json\'\n'http://cesLocation:48226/ispw/w3t/assignments/FOO1000019/tasks/7E188CE31055/listing'</pre><h4>Example: 200 Response</h4>\n<pre>{\n    \"listing\": \"{Generate Listing output}\"\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"assignmentid",
                        "description":"The ID of the assignment you want information on."
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"taskid",
                        "description":" The ID of the task you want a listing for."
                    }
                ],
                "responses": {
                	"200": {
                		"description": "Success - this code indicates that the request completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"405": {
                		"description": "Error - this call requires a Get. Confirm that a Get was used."
                	}
                }
            }
        },
        "/{srid}/build":{
            "post":{
            	"summary":"Build one or more tasks. The valid SetInfo fields are runtimeConfiguration, taskId, changeType, events, and execStat.",
            	"description":"<h4>Example: Build task with multiple task IDs \"7E382B6270DC\" \"7E3AEB250B94\" </h4>\n<pre>curl --request POST \n  --url \'http://cesLocation:48226/ispw/build?taskId=7E382B6270DC&taskId=7E3AEB250B94\' \n  --header \'authorization: 0148da8e-a20a-4510-9005-b6daafb443c1\' \n  --header \'content-type: application/json\' \n  --data \'{\n	\"runtimeConfiguration\" : \"FOOBAR\"\n	\"events\": [{\n        \"name\": \"complete\",\n        \"url\":\"https://hooks.slack.com/services/lkj3hul3/jhadsi8yasd/li8asij2d90jmnas\",\n        \"body\":\n        {\n            \"text\": \"FOO built from DEV1!\"\n        }\n    }]\n}\'</pre>\n<h4>Example: Build task with level \"DEV1\", application \"PLAY\", type \"COPY\", name \"TCPYB05\"</h4>\n<pre>curl --request POST \n  --url \'http://cesLocation:48226/ispw/build?level=DEV1&application=PLAY&mtype=COPY&mname=TCPYB05\' \n  --header \'authorization: 0148da8e-a20a-4510-9005-b6daafb443c1\' \n  --header \'content-type: application/json\' \n  --data \'{\n	\"runtimeConfiguration\" : \"FOOBAR\"\n}\'</pre>\n<h4>Example: 200 Response</h4>\n<pre>{\n  \"setId\": \"S000001048\",\n  \"assignmentId\": \"PLAY000084\",\n  \"url\": \"http://cesLocation:48226/ispw/sets/S000001048\",\n  \"tasks\": [\n    {\n      \"application\": \"PLAY\",\n      \"currentLevel\": \"DEV1\",\n      \"moduleName\": \"TPROG05\",\n      \"moduleType\": \"COB\",\n      \"stream\": \" \",\n      \"taskId\": \"7E382CEE2798\"\n    },\n    {\n      \"application\": \"PLAY\",\n      \"currentLevel\": \"DEV1\",\n      \"moduleName\": \"TSUBR05\",\n      \"moduleType\": \"COB\",\n      \"stream\": \" \",\n      \"taskId\": \"7E382CEE27AC\"\n    }\n  ]\n}\n</pre>\n<br><br>",
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true,
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "type":"string",
                        "name":"application",
                        "in":"query",
                        "required":true,
                        "description":"A task with this application will be built."
                    },
                    {
                        "type":"string",
                        "name":"assignmentId",
                        "in":"query",
                        "required":false,
                        "description":"The ID of the assignment to build the task in. This will be looked up if it's not specified."
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true,
                        "description":"A task at this level will be built."
                    },
                    {
                        "type":"string",
                        "name":"mname",
                        "in":"query",
                        "required":true,
                        "description":"A task with this name will be built."
                    },
                    {
                        "type":"string",
                        "name":"mtype",
                        "in":"query",
                        "required":true,
                        "description":"A task of this type will be built."
                    },
                    {
                        "type":"string",
                        "name":"taskId",
                        "in":"query",
                        "required":false,
                        "description":"A task with this task ID will be built. If the task ID is specified then application, level, mname, and mtype are not required."
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "description":"The data used to perform a build.",
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"Build Initiated - the build has been started.",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/BuildResponse"
                        }
                    },
                    "400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"409": {
                		"description": "Conflict - a referenced entity could not be found or caused a conflict."
                	},
                	"500": {
                		"description": "Server Error - An error occurred while attempting to login to ISPW."
                	}
                },
                "tags":[
                    "build"
                ]
            }
        },
        "/{srid}/componentVersions/list":{
            "get":{
                "summary":"List component versions by providing application ID, component name and component type.",
                "description": "<h4>Example: Get a list of component versions for application \"PLAY\", component name \"TREXX02\" and component type \"CLST\"</h4>\n<pre>curl -XGET -H \'Authorization: 097548e7-fc41-479d-ad89-fe9c61466ea9\' -H \'Content-type: application/json\' \'http://cesLocation:48226/ispw/w3t/componentVersions/list?application=PLAY&mname=TREXX02&mtype=/CLST\'</pre><h4>Example: 200 Response</h4>\n<pre>{\n \"componentVersions\":[\n {\n \"action\": \"\",\n \"alternateName\": \" \",\n \"application\": \"PLAY\",\n \"assignmentId\": \"PLAY000762\",\n \"baseVersion\": 25,\n \"checkoutDateTime\": \"2018-06-05 12:06:45\",\n \"dateTime\": \"2018-08-02 09:59:48\",\n \"environment\": \"HOLD\",\n \"internalVersion\": 38,\n \"level\": \"QA\",\n \"message\": \" \",\n \"operation\": \"Implement\",\n \"owner\": \"EFHKAT0\",\n \"path\": \"DEV1\",\n \"replaceVersion\": 25,\n \"status\": \"\",\n \"stream\": \"PLAY\",\n \"userId\": \"EFHKAT0\",\n \"version\": 38\n }, \n { \n \"action\": \"\",\n \"alternateName\": \" \",\n \"application\": \"PLAY\",\n \"assignmentId\": \"PLAY000384\",\n \"baseVersion\": 2,\n \"checkoutDateTime\": \"2017-11-03 07:46:37\",\n \"dateTime\": \"2017-11-03 07:47:45\",\n \"environment\": \"PROD\",\n \"internalVersion\": 25,\n \"level\": \"PRD\",\"message\": \" \",\n \"operation\": \"Promote\",\n \"owner\": \"PFHGJW0\",\n \"path\": \"DEV1\",\n \"replaceVersion\": 2,\n \"status\": \"\",\n \"stream\": \"PLAY\",\n \"userId\": \"PFHGJW0\",\n \"version\": 25\n },\n {\n \"action\": \"\",\n \"alternateName\": \" \",\n \"application\": \"PLAY\",\n \"assignmentId\": \"PLAY000585\",\n \"baseVersion\": 0,\n \"checkoutDateTime\": \"2018-07-06 13:29:49\",\n \"dateTime\": \"2018-07-12 12:22:02\",\n \"environment\": \"TEST\",\n \"internalVersion\": 0,\n \"level\": \"FIX\",\n \"message\": \"Replacing V36\",\n \"operation\": \"Regress\",\n\ \"owner\": \"EFHKAT0\",\n \"path\": \"FIX\",\n \"replaceVersion\": 25,\n \"status\": \"\",\n \"stream\": \"PLAY\",\n \"userId\": \"EFHKAT0\",\n \"version\": 0 \n} \n] \n}</pre><br><br>",            
                "parameters":[
                    {
                        "name":"application",
                        "description":"The application name." 
                    },
                 	{
                        "name":"mname",
                        "description":"The component name within the application that you want component versions for."
                    },
                    {
                        "name":"mtype",
                        "description":"The component type that the component name is associated with."
                    },
                 ],
                "responses": {
                	"200": {
                		"description": "Success - this code indicates that the request completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"405": {
                		"description": "Error - this call requires a Get. Confirm that a Get was used."
                	}
                }
            }
         },
        "/{srid}/assignments/{assignmentid}/tasks/transfer":{
            "post":{
                "summary":"Transfer one or more tasks from an assignment to another assignment or release",
                "description": "<h4>Example: Transfer all tasks at DEV1 level from assignment \"ASSIGN123\" to assignment \"ASSIGN456\"</h4>\n<pre class=\'example\'>json body:\n{\n  \"runtimeConfiguration\" : \"FOOBAR\"\n \"containerId\" : \"ASSIGN456\"\n \"containerType\" : \"A\"\n}\n\n\ncurl -XPOST -H \'Authorization: 097548e7-fc41-479d-ad89-fe9c61466ea9\'  -H \'Content-type: application/json\' -d \"$json\" \'http://cesLocation:48226/ispw/w3t/assignments/ASSIGN123/tasks/transfer?level=DEV1\'</pre><h4>Example: 201 Response</h4><pre>{\n\t\"message\": \"Successfully transferred 2 out of 2 total task(s) from assignment ASSIGN123 to assignment ASSIGN456\",\n\t\"url\": \"http://cesLocation.com:48226/ispw/w3t/assignments/ASSIGN123\"\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"assignmentid",
                        "description":"The ID of the assignment you want to transfer tasks from"
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"level",
                        "description":" The current level of tasks you want to transfer"
                    },
                    {
                        "name":"mname",
                        "description":" The task member name that you want to transfer"
                    },
                    {
                        "name":"mtype",
                        "description":"The task type that you want to transfer"
                    },
                    {
                        "name":"taskId",
                        "description":"The task ID that you want to transfer"
                    },
                    {
                        "name":"body",
                        "description":"The data used to create the task in the assignment."
                    }
                ],
                "responses": {
                	"200": {
                		"description": "Success - this code indicates that the request completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"405": {
                		"description": "Error - this call requires a Post. Confirm that a Post was used."
                	}
                }
            }
        },
        "/{srid}/deployments/{requestId}/modify":{
            "post":{
                "summary":"Cancel a deployment by deployment request ID.",
                "description": "<h4>Example: Modify a deployment \"123456789\"</h4>\n<pre class=\'example\'>json body:\n{\n  \"runtimeConfiguration\" : \"FOOBAR\"\n}\n</pre><h4>Example: 200 Response</h4><pre>{\n\t\"requestId\": 123456789,\n\t\"url\": \"http://cesLocation.com:48226/ispw/w3t/sets/S123456789/deployment\"\n}</pre><br><br>",
                "parameters":[
                    {
                        "type":"integer",
                        "name":"requestId",
                        "in":"path",
                        "required":true,
                        "description": "The request ID"
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true,
                        "description": "The server ID"
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/DeployModifyInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeploymentResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeploymentResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeploymentResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/DeploymentResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        }
                    }
                },
                "tags":[
                    "deployments"
                ]
            }
        },
        "/{srid}/containers/list":{
            "get":{
                "summary":"List containers using optional filter criteria",
                "description": "<h4>Example: Get a list of containers for stream \"PLAY\", application \"PLAY\" and user \"FOOUSER\"</h4>\n<pre>curl -XGET -H \'Authorization: 097548e7-fc41-479d-ad89-fe9c61466ea9\' -H \'Content-type: application/json\' \'http://cesLocation:48226/ispw/w3t/containers/list?stream=PLAY&application=PLAY&userId=FOOUSER\'</pre><h4>Example: 200 Response</h4>\n<pre>{\n    \"containers\": [\n    {\n        \"application\": \"PLAY\",\n        \"containerId\": \"PLAY000001\",\n        \"containerType\": \"A\",\n        \"description\": \"Assignment 1\",\n        \"owner\": \"FOOUSER\",\n        \"path\": \"DEV1\",\n        \"refNumber\": \" \",\n        \"releaseId\": \"\",\n        \"stream\": \"PLAY\",\n        \"tag\": \" \" \n },\n{\n        \"application\": \"PLAY\",\n        \"containerId\": \"PLAY000002\",\n        \"containerType\": \"A\",\n        \"description\": \"Assignment 2\",\n        \"owner\": \"FOOUSER\",\n        \"path\": \"DEV1\",\n        \"refNumber\": \" \",\n        \"releaseId\": \"\",\n        \"stream\": \"PLAY\",\n        \"tag\": \" \" \n } ] \n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"application",
                        "description":"The application. Trailing wildcards are supported, i.e. FOO*"
                    },
                    {
                        "name":"containerId",
                        "description":"The container ID (Assignment ID, Release ID or Set ID). Trailing wildcards are supported, i.e. PRFX0000*"
                    },
                    {
                        "name":"containerType",
                        "description":"The container type: A=Assignment, R=Release S=Set"
                    },
                    {
                        "name":"description",
                        "description":"The container description.  Trailing wildcards may be used such that REF123* would match both REF123456 and REF123999 (Case sensitive)"
                    },
                    {
                        "name":"includeClosedContainers",
                        "description":"true/false value indicating whether or not to include closed containers.  The default value is false."
                    },
                    {
                        "name":"owner",
                        "description":"The container owner. Trailing wildcards are supported, i.e. MYID*"
                    },
                    {
                        "name":"path",
                        "description":"The default container path. Trailing wildcards are supported, i.e. DEV*"
                    },
                    {
                        "name":"refNumber",
                        "description":"The reference number. Trailing wildcards are supported, i.e. MYISSUE*"
                    },
                    {
                        "name":"releaseId",
                        "description":"The release ID. Trailing wildcards are supported, i.e. RELEASE1*"
                    },
                    {
                        "name":"stream",
                        "description":"The stream. Trailing wildcards are supported, i.e. BAR*"
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"tag",
                        "description":"The user tag. Trailing wildcards are supported, i.e. TAG* (Case sensitive)"
                    },
                    {
                        "name":"userId",
                        "description":"The user ID. The user ID associated with the container"
                    },
                 ],
                "responses": {
                	"200": {
                		"description": "Success - this code indicates that the request completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"405": {
                		"description": "Error - this call requires a Get. Confirm that a Get was used."
                	}
                }
            }
        },
        "/{srid}/deployments/{requestId}/cancel":{
            "post":{
                "summary":"Cancel a deployment by deployment request ID. The valid SetInfo fields are runtimeConfiguration, events, httpHeaders and credentials.",
                "description": "<h4>Example: Cancel a deployment \"123456789\"</h4>\n<pre class=\'example\'>json body:\n{\n  \"runtimeConfiguration\" : \"FOOBAR\"\n}\n</pre><h4>Example: 200 Response</h4><pre>{\n\t\"requestId\": 123456789,\n\t\"url\": \"http://cesLocation.com:48226/ispw/w3t/sets/S123456789/deployment\"\n}</pre><br><br>",
                "parameters":[
                    {
                        "type":"long",
                        "name":"requestId",
                        "in":"path",
                        "required":true,
                        "description": "The request ID"
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true,
                        "description": "The server ID"
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                	"201": {
                		"description": "Canceled - this code indicates that the request to cancel a deployment completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON Response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	}
                }
            }
        },
         "/{srid}/promotionAnalysis":{
            "post":{
            "summary":"Run promotion analysis on a set of tasks. Checks whether all the specified tasks  are ready to be promoted.",
            "description":"<h4>Example: Promotion Analysis of tasks with task IDs \"7E3ABB4D22AA\" and \"7E3C53D37ED4\"</h4>\n<pre>curl --request POST \n  --url \'http://cesLocation:48226/ispw/w3t/promotionAnalysis?taskId=7E3ABB4D22AA&taskId=7E3C53D37ED4' \n  --header \'authorization: 0148da8e-a20a-4510-9005-b6daafb443c1\' \n  --header \'content-type: application/json\' \n  --data \'{\n	\"runtimeConfiguration\" : \"FOOBAR\"\n}\'</pre>\n<h4>Example: 200 Response</h4>\n<pre>{\n  \"numberOfErrors\": 1,\n  \"numberOfWarnings\": 0,\n  \"numberOfInfos\": 1,\n  \"timeOfAnalysis\": \"Wed Jan 15 15:27\",\n  \"containerId\": \"PLAY000084\",\n  \"numberOfTasksAnalyzed\": 2\n}\n</pre>\n<br><br>",
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"taskId",
                        "in":"query",
                        "required":true,
                        "description":"The task ID of the task that needs to be analyzed"
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true,
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                    	"description":"Promotion Analysis completed successfully",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/PromotionAnalysisResponse"
                        }
                    },
                    "400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"409": {
                		"description": "Conflict - a referenced entity could not be found or caused a conflict."
                	},
                	"500": {
                		"description": "Server Error - An error occurred while attempting to login to ISPW."
                	}
                },
                "tags":[
                    "promotionAnalysis"
                ]
            }
        },
        "/{srid}/commits/{commitHash}/tasks/deploy":{ 
            "post":{
                "summary":"Deploys tasks based on a commit. You may use task IDs to deploy specific tasks in that commit. The valid DeployInfo fields are all fields.",
                  "description":"<h4>Example: Deploy tasks with multiple task IDs \"7E382B6270DC\" \"7E3AEB250B94\" at level DEV1 in a commit \"a645829890892e53266b7b544479f994ae27dee2\"</h4>\n<pre>curl --request POST \n  --url \'http://cesLocation:48226/ispw/commits/a645829890892e53266b7b544479f994ae27dee2/tasks/deploy?level=DEV1&taskId=7E382B6270DC&taskId=7E3AEB250B94\' \n  --header \'authorization: 0148da8e-a20a-4510-9005-b6daafb443c1\' \n  --header \'content-type: application/json\' \n  --data \'{\n	\"runtimeConfiguration\" : \"FOOBAR\"\n	\"events\": [{\n        \"name\": \"complete\",\n        \"url\":\"https://hooks.slack.com/services/lkj3hul3/jhadsi8yasd/li8asij2d90jmnas\",\n        \"body\":\n        {\n            \"text\": \"FOO deployed from DEV1!\"\n        }\n    }]\n}\'</pre>\n<h4>Example: 200 Response</h4>\n<pre>{\n  \"setId\": \"S000001048\",\n  \"message\": \"\",\n  \"url\": \"http://cesLocation:48226/ispw/sets/S000001048\"\n}\n</pre>\n<br><br>",
                "parameters":[
                    {
                        "type":"string",
                        "name":"commitHash",
                        "in":"path",
                        "required":true,
                        "description":"The commit hash that is associated with the tasks to be deployed."
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true,
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true,
                        "description":"A task at this level will be deployed."
                    },
                    {
                        "type":"string",
                        "name":"taskId",
                        "in":"query",
                        "required":false,
                        "description":"A task with this task ID will be deployed."
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "description":"The data used to perform a deploy.",
                        "schema":{
                            "$ref":"#/definitions/DeployInfo"
                        }
                    }
                ],
                "responses": {
                	"200": {
                		"description": "Deployed - this code indicates that the request to deploy in a commit with task IDs completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"409": {
                		"description": "Conflict - a referenced entity could not be found or caused a conflict."
                	},
                	"500": {
                		"description": "Server Error - An error occurred while attempting to login to ISPW."
                	}
                }
            }
        },
        "/{srid}/commits/{commitHash}/tasks/generate":{ 
            "post":{
                "summary":"Generates tasks based on a commit. You may use task IDs to generate specific tasks in that commit. The valid SetInfo fields are runtimeConfiguration, autoDeploy, taskId, changeType, events, and execStat.",
                  "description":"<h4>Example: Generate tasks with multiple task IDs \"7E382B6270DC\" \"7E3AEB250B94\" at level DEV1 in a commit \"a645829890892e53266b7b544479f994ae27dee2\"</h4>\n<pre>curl --request POST \n  --url \'http://cesLocation:48226/ispw/commits/a645829890892e53266b7b544479f994ae27dee2/tasks/generate?level=DEV1&taskId=7E382B6270DC&taskId=7E3AEB250B94\' \n  --header \'authorization: 0148da8e-a20a-4510-9005-b6daafb443c1\' \n  --header \'content-type: application/json\' \n  --data \'{\n	\"runtimeConfiguration\" : \"FOOBAR\"\n	\"events\": [{\n        \"name\": \"complete\",\n        \"url\":\"https://hooks.slack.com/services/lkj3hul3/jhadsi8yasd/li8asij2d90jmnas\",\n        \"body\":\n        {\n            \"text\": \"FOO generated from DEV1!\"\n        }\n    }]\n}\'</pre>\n<h4>Example: 200 Response</h4>\n<pre>{\n  \"setId\": \"S000001048\",\n  \"message\": \"\",\n  \"url\": \"http://cesLocation:48226/ispw/sets/S000001048\"\n}\n</pre>\n<br><br>",
                "parameters":[
                    {
                        "type":"string",
                        "name":"commitHash",
                        "in":"path",
                        "required":true,
                        "description":"The commit hash that is associated with the tasks to be generated."
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true,
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true,
                        "description":"A task at this level will be generated."
                    },
                    {
                        "type":"string",
                        "name":"taskId",
                        "in":"query",
                        "required":false,
                        "description":"A task with this task ID will be generated."
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "description":"The data used to perform a generate.",
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses": {
                	"200": {
                		"description": "Generated - this code indicates that the request to generate in a commit with task IDs completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"409": {
                		"description": "Conflict - a referenced entity could not be found or caused a conflict."
                	},
                	"500": {
                		"description": "Server Error - An error occurred while attempting to login to ISPW."
                	}
                }
            }
        },
        "/{srid}/releases":{
            "post":{
                "summary":"Create a release",
                "description":"<h4>Example: Create a release for application \"FOO\", stream \"BAR\", with the ID \"FB123\"</h4>\n<pre>json body:\n{\n    \"stream\":\"BAR\",\n    \"application\":\"FOO\",\n    \"releaseId\":\"FB123\",\n    \"description\":\"release for foobar\"\n}</pre><h4>Example: 201 Response</h4>\n<pre>{\n    \"releaseId\":\"ISPW2345\",\n    \"message:\"\",\n   \"url\":\"http://cesLocation:48226/ispw/w3t/releases/ISPW2345\" // URL to GET Release\n}</pre><br><br><h4>Example: Create a release for application \"FOO\", stream \"BAR\", with the release prefix \"PRFX\"</h4>\n<pre>json body:\n{\n    \"stream\":\"BAR\",\n    \"application\":\"FOO\",\n    \"releasePrefix\":\"PRFX\",\n    \"description\":\"release generated using prefix\"\n}</pre><h4>Example: 201 Response</h4>\n<pre>{\n    \"releaseId\":\"PRFX000001\",\n    \"message:\"\",\n   \"url\":\"http://cesLocation:48226/ispw/w3t/releases/PRFX000001\" // URL to GET Release\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"body",
                        "description":"The data used to create a release."
                    }
                ],
                "responses": {
                	"201": {
                		"description": "Created - this code indicates that the request to create a release completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	}
                }
            }
        },
        "/{srid}/releases/{releaseId}/cancel":{
            "post":{
                "summary":"Cancel a release. The valid SetInfo fields are runtimeConfiguration, events, httpHeaders and credentials.",
                "description": "<h4>Example: Cancel a release \"RELEASE123\"</h4>\n<pre class=\'example\'>json body:\n{\n  \"runtimeConfiguration\" : \"FOOBAR\"\n}\n</pre><h4>Example: 201 Response</h4><pre>{\n\t\"releaseId\": \"RELEASE123\",\n\t\"url\": \"http://cesLocation.com:48226/ispw/w3t/releases/RELEASE123/cancel\"\n}</pre><br><br>",
                "parameters":[
                    {
                        "type":"string",
                        "name":"releaseid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                	"201": {
                		"description": "Canceled - this code indicates that the request to cancel a release completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"500": {
                		"description": "Error - the Prefix is not one which is defined to the system. Use a defined Prefix and try again. If you do not know the defined Prefixes, contact your ISPW Administrator for assistance."
                	}
                }
            }
        },
        "/{srid}/releases/{releaseId}/close":{
            "post":{
                "summary":"Close a release. The valid SetInfo fields are runtimeConfiguration, events, httpHeaders and credentials.",
                "description": "<h4>Example: close a release \"RELEASE123\"</h4>\n<pre class=\'example\'>json body:\n{\n  \"runtimeConfiguration\" : \"FOOBAR\"\n}\n</pre><h4>Example: 201 Response</h4><pre>{\n\t\"releaseId\": \"RELEASE123\",\n\t\"url\": \"http://cesLocation.com:48226/ispw/w3t/releases/RELEASE123/close\"\n}</pre><br><br>",
                "parameters":[
                    {
                        "type":"string",
                        "name":"releaseid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                	"201": {
                		"description": "Closed - this code indicates that the request to close a release completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"500": {
                		"description": "Error - the prefix is not one which is defined to the system. Use a defined prefix and try again. If you do not know the defined prefixes, contact your ISPW Administrator for assistance."
                	}
                }
            }
        },
        "/{srid}/releases/{releaseId}/tasks":{
            "get":{
                "summary":"List tasks in the specified release",
                "description": "<h4>Example: Get task list for release \"FOO1000019\"</h4>\n<pre>curl -XGET -H \'Authorization: 097548e7-fc41-479d-ad89-fe9c61466ea9\' -H \'Content-type: application/json\' \'http://cesLocation:48226/ispw/w3t/releases/FOO1000019/tasks\'</pre><h4>Example: 200 Response</h4>\n<pre>{\n    \"tasks\": [\n    {\n        \"action\": \" \",\n        \"alternateName\": \" \",\n        \"application\": \"FOO\",\n        \"container\": \"F001000019\",\n        \"baseVersion\": 0,\n        \"cics\": false,\n        \"clazz\": \" \",\n        \"dateTime\": \"2017-08-30 15:44:47\",\n        \"environment\": \"TEST\",\n        \"extension\": \" \",\n        \"flags\": \"Y\",\n        \"ims\": false,\n        \"internalVersion\": 0,\n        \"level\": \"DEV1\",\n        \"message\": \"OK\",\n        \"operation\": \"G\",\n        \"path\": \"DEV1\",\n        \"program\": true,\n        \"release\": \"REL1\",\n        \"replaceVersion\": 0,\n        \"set\": \" \",\n        \"sql\": false,\n        \"status\": \" \",\n        \"stream\": \"BAR\",\n        \"taskId\": \"7E12E3B57A02\",\n        \"type\": \"COB\",\n        \"userId\": \"FOOUSER\",\n        \"version\": 0,\n        \"memberName\": \"COBGOOD1\"\n    },\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"releaseId",
                        "description":"The ID of the release you want information on."
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"level",
                        "description":"All tasks in the release at this level will be displayed."
                    }
                ],
                "responses": {
                	"200": {
                		"description": "Success - this code indicates that the request completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"405": {
                		"description": "Error - this call requires a Get. Confirm that a Get was used."
                	}
                }
            }
        },
        "/{srid}/releases/{releaseId}/tasks/build":{
            "post":{
            	"summary":"Build a release. The valid SetInfo fields are runtimeConfiguration, changeType, events, and execStat.",
            	"description":"<h4>Example: Build tasks at level \"DEV1\" in release \"FOO1000019\" and assignment \"\"PLAY000100\"</h4>\n<pre>curl --request POST \n  --url \'http://cesLocation:48226/ispw/releases/FOO1000019/tasks/build?level=DEV1&assignmentId=PLAY000100\' \n  --header \'authorization: 0148da8e-a20a-4510-9005-b6daafb443c1\' \n  --header \'content-type: application/json\' \n  --data \'{\n	\"runtimeConfiguration\" : \"DV6DEV6T\"\n	\"events\": [{\n        \"name\": \"complete\",\n        \"url\":\"https://hooks.slack.com/services/lkj3hul3/jhadsi8yasd/li8asij2d90jmnas\",\n        \"body\":\n        {\n            \"text\": \"FOO built from DEV1!\"\n        }\n    }]\n}\'</pre>\n<h4>Example: 200 Response</h4>\n<pre>{\n  \"setId\": \"S000001046\",\n  \"assignmentId\": \"PLAY000084\",\n  \"url\": \"http://cesLocation:48226/ispw/sets/S000001046\",\n  \"tasks\": [\n    {\n      \"application\": \"PLAY\",\n      \"currentLevel\": \"DEV1\",\n      \"moduleName\": \"TPROG05\",\n      \"moduleType\": \"COB\",\n      \"stream\": \" \",\n      \"taskId\": \"7E382BCBBCBA\"\n    },\n    {\n      \"application\": \"PLAY\",\n      \"currentLevel\": \"DEV1\",\n      \"moduleName\": \"TSUBR05\",\n      \"moduleType\": \"COB\",\n      \"stream\": \" \",\n      \"taskId\": \"7E382BCBBCF4\"\n    }\n  ]\n}\n</pre>\n<br><br>",
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"releaseId",
                        "in":"path",
                        "required":true,
                        "description":"The ID of the release to build."
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true,
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "type":"string",
                        "name":"assignmentId",
                        "in":"query",
                        "required":true,
                        "description":"The ID of the assignment to add the impacts to during the build."
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true,
                        "description":"Tasks in the release at this level will be built."
                    },
                    {
                        "type":"string",
                        "name":"mname",
                        "in":"query",
                        "required":false,
                        "description":"Components with this name in the release will be built, if specified."
                    },
                    {
                        "type":"string",
                        "name":"mtype",
                        "in":"query",
                        "required":false,
                        "description":"Component of this type in the release will be built, if specified."
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "description":"The data used to perform a build.",
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                        "description":"Build Initiated - the build has been started.",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/BuildResponse"
                        }
                    },
                    "400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"409": {
                		"description": "Conflict - a referenced entity could not be found or caused a conflict."
                	},
                	"500": {
                		"description": "Server Error - An error occurred while attempting to login to ISPW."
                	}
                },
                "tags":[
                    "releases"
                ]
            }
        },
        "/{srid}/releases/{releaseId}/tasks/deploy":{
            "post":{
                "summary":"Deploy a release. The valid DeployInfo fields are all fields except for taskId.",
                "description": "<h4>Example: Deploy \"FOO\" from level \"qa\". On success, POST notification to Slack.</h4>\n<pre>json body:\n{\n    \"runtimeConfiguration\": \"FOOBAR\",\n    \"events\": [{\n        \"name\": \"complete\",\n        \"url\":\"https://hooks.slack.com/services/lkj3hul3/jhadsi8yasd/li8asij2d90jmnas\",\n        \"body\": {\"text\": \"FOO promoted from qa!\"\n        }\n    }]\n}</pre><h4>Example: 201 Response</h4>\n<pre>{\n    \"setId\":\"ISPW2345\",\n    \"message:\"\",\n    \"url\":\"http://cesLocation:48226/ispw/w3t/sets/s0123456\" // URL to GET Set\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"releaseId",
                        "description":" The ID of the release you intend to deploy."
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"level",
                        "description":"Tasks in the release at this level will be deployed."
                    },
                    {
                        "name":"mname",
                        "description":"Components with this name in the release will be deployed if specified."
                    },
                    {
                        "name":"mtype",
                        "description":"Components of this type in the release will be deployed if specified."
                    },
                    {
                        "name":"body",
                        "description":"The data used to perform a deploy."
                    }
                ],
                "responses": {
                	"201": {
                		"description": "Created - this code indicates that the request to deploy a release completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	}
                }
            }
        },
        "/{srid}/releases/{releaseId}/taskIds/deploy":{ 
            "post":{
                "summary":"Deploys tasks in a release. You may use task IDs to deploy specific tasks in that release. The valid DeployInfo fields are all fields.",
                "description":"<h4>Example: Deploy tasks with multiple task IDs \"7E382B6270DC\" \"7E3AEB250B94\" at level DEV1 in a release \"FOO1000019\"</h4>\n<pre>curl --request POST \n  --url \'http://cesLocation:48226/ispw/releases/FOO1000019/taskIds/deploy?level=DEV1&taskId=7E382B6270DC&taskId=7E3AEB250B94\' \n  --header \'authorization: 0148da8e-a20a-4510-9005-b6daafb443c1\' \n  --header \'content-type: application/json\' \n  --data \'{\n	\"runtimeConfiguration\" : \"FOOBAR\"\n	\"events\": [{\n        \"name\": \"complete\",\n        \"url\":\"https://hooks.slack.com/services/lkj3hul3/jhadsi8yasd/li8asij2d90jmnas\",\n        \"body\":\n        {\n            \"text\": \"FOO deployed from DEV1!\"\n        }\n    }]\n}\'</pre>\n<h4>Example: 200 Response</h4>\n<pre>{\n  \"setId\": \"S000001048\",\n  \"message\": \"\",\n  \"url\": \"http://cesLocation:48226/ispw/sets/S000001048\"\n}\n</pre>\n<br><br>",
                "parameters":[
                    {
                        "type":"string",
                        "name":"releaseId",
                        "in":"path",
                        "required":true,
                        "description":"The ID of the release the tasks reside in."
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true,
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true,
                        "description":"A task at this level will be deployed."
                    },
                    {
                        "type":"string",
                        "name":"taskId",
                        "in":"query",
                        "required":false,
                        "description":"A task with this task ID will be deployed."
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "description":"The data used to perform a deployment.",
                        "schema":{
                            "$ref":"#/definitions/DeployInfo"
                        }
                    }
                ],
                "responses": {
                	"200": {
                		"description": "Deployed - this code indicates that the request to deploy in a release with task IDs completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"409": {
                		"description": "Conflict - a referenced entity could not be found or caused a conflict."
                	},
                	"500": {
                		"description": "Server Error - An error occurred while attempting to login to ISPW."
                	}
                }
            }
        },
        "/{srid}/releases/{releaseId}/tasks/fallback":{
            "post":{
                "summary":"Fallback a release.",
                "description":"<h4>Example: Fallback \"FOO\" from level \"qa\". On success, POST notification to Slack.</h4>\n<pre>json body:\n{\n    \"runtimeConfiguration\": \"FOOBAR\",\n    \"events\": [{\n        \"name\": \"complete\",\n        \"url\":\"https://hooks.slack.com/services/lkj3hul3/jhadsi8yasd/li8asij2d90jmnas\",\n        \"body\":\n        {\n            \"text\": \"FOO fallback from qa!\"\n        }\n    }]\n}\ncurl -XPOST -H \'Authorization: 097548e7-fc41-479d-ad89-fe9c61466ea9\'  -H \'Content-type: application/json\' -d \"$json\" \'http://cesLocation:48226/ispw/w3t/releases/FOO/tasks/fallback?level=qa\'</pre><h4>Example: 201 Response</h4>\n<pre>{\n    \"setId\":\"ISPW2345\",\n    \"message:\"\",\n    \"url\":\"http://cesLocation:48226/ispw/w3t/sets/s0123456\" // URL to GET Set\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"releaseId",
                        "description":" The ID of the release you intend to fallback."
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"level",
                        "description":"Tasks in the release at this level will fallback."
                    },
                    {
                        "name":"mname",
                        "description":"Components with this name in the release will fallback if specified."
                    },
                    {
                        "name":"mtype",
                        "description":"Components of this type in the release will fallback if specified."
                    },
                    {
                        "name":"body",
                        "description":"The data used to perform a fallback."
                    }
                ],
                "responses": {
                	"201": {
                		"description": "Fallback - this code indicates that the request to fallback a release completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	}
                }
            }
        },
        "/{srid}/releases/{releaseId}/tasks/generate":{
            "post":{
                "summary":"Generate tasks in a release. The valid SetInfo fields are runtimeConfiguration, autoDeploy, changeType, executionStatus, httpHeaders, credentials and events.",
                "description":"<h4>Example: Generate tasks at level \"qa\" in release \"FB000001\"</h4>\n<pre>json body:\n{\n    \"runtimeConfiguration\": \"FOOBAR\",\n    \"events\": [{\n        \"name\": \"complete\",\n        \"url\":\"https://hooks.slack.com/services/lkj3hul3/jhadsi8yasd/li8asij2d90jmnas\",\n        \"body\":\n        {\n            \"text\": \"FOO generated from qa!\"\n        }\n    }]\n}\ncurl -XPOST -H \'Authorization: 097548e7-fc41-479d-ad89-fe9c61466ea9\'  -H \'Content-type: application/json\' -d \"$json\" \'http://cesLocation:48226/ispw/w3t/releases/FB000001/tasks/generate?level=qa\'</pre><h4>Example: 201 Response</h4>\n<pre>{\n    \"setId\":\"ISPW2345\",\n    \"message:\"\",\n    \"url\":\"http://cesLocation:48226/ispw/w3t/sets/s0123456\" // URL to GET Set\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"releaseId",
                        "description":"The ID of the release you intend to generate tasks."
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"level",
                        "description":"Tasks in the release at this level will be generated."
                    },
                    {
                        "name":"mname",
                        "description":"Components with this name in the release will be generated if specified."
                    },
                    {
                        "name":"mtype",
                        "description":"Components of this type in the release will be generated if specified."
                    },
                    {
                        "name":"body",
                        "description":"The data used to perform a generate."
                    }
                ],
                "responses": {
                	"201": {
                		"description": "Generated - this code indicates that the request to generate in an assignment completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	}
                }
            }
        },
        "/{srid}/releases/{releaseId}/taskIds/generate":{ 
            "post":{
                "summary":"Generates tasks in a release. You may use task IDs to generate specific tasks in that release. The valid SetInfo fields are runtimeConfiguration, autoDeploy, taskId, changeType, events, and execStat.",
                  "description":"<h4>Example: Generate tasks with multiple task IDs \"7E382B6270DC\" \"7E3AEB250B94\" at level DEV1 in a release \"FOO1000019\"</h4>\n<pre>curl --request POST \n  --url \'http://cesLocation:48226/ispw/releases/FOO1000019/taskIds/generate?level=DEV1&taskId=7E382B6270DC&taskId=7E3AEB250B94\' \n  --header \'authorization: 0148da8e-a20a-4510-9005-b6daafb443c1\' \n  --header \'content-type: application/json\' \n  --data \'{\n	\"runtimeConfiguration\" : \"FOOBAR\"\n	\"events\": [{\n        \"name\": \"complete\",\n        \"url\":\"https://hooks.slack.com/services/lkj3hul3/jhadsi8yasd/li8asij2d90jmnas\",\n        \"body\":\n        {\n            \"text\": \"FOO generated from DEV1!\"\n        }\n    }]\n}\'</pre>\n<h4>Example: 200 Response</h4>\n<pre>{\n  \"setId\": \"S000001048\",\n  \"message\": \"\",\n  \"url\": \"http://cesLocation:48226/ispw/sets/S000001048\"\n}\n</pre>\n<br><br>",
                "parameters":[
                    {
                        "type":"string",
                        "name":"releaseId",
                        "in":"path",
                        "required":true,
                        "description":"The ID of the release the tasks reside in."
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true,
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "type":"string",
                        "name":"level",
                        "in":"query",
                        "required":true,
                        "description":"A task at this level will be generated."
                    },
                    {
                        "type":"string",
                        "name":"taskId",
                        "in":"query",
                        "required":false,
                        "description":"A task with this task ID will be generated."
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "description":"The data used to perform a generate.",
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses": {
                	"200": {
                		"description": "Generated - this code indicates that the request to generate in a release with task IDs completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"409": {
                		"description": "Conflict - a referenced entity could not be found or caused a conflict."
                	},
                	"500": {
                		"description": "Server Error - An error occurred while attempting to login to ISPW."
                	}
                }
            }
        },
        "/{srid}/releases/{releaseId}/tasks/promote":{
            "post":{
                "summary":"Promote a release.",
                "description":"<h4>Example: Promote \"FOO\" from level \"qa\". On success, POST notification to Slack.</h4>\n<pre>json body:\n{\n    \"runtimeConfiguration\": \"FOOBAR\",\n    \"events\": [{\n        \"name\": \"complete\",\n        \"url\":\"https://hooks.slack.com/services/lkj3hul3/jhadsi8yasd/li8asij2d90jmnas\",\n        \"body\":\n        {\n            \"text\": \"FOO promoted from qa!\"\n        }\n    }]\n}\ncurl -XPOST -H \'Authorization: 097548e7-fc41-479d-ad89-fe9c61466ea9\'  -H \'Content-type: application/json\' -d \"$json\" \'http://cesLocation:48226/ispw/w3t/releases/FOO/tasks/promote?level=qa\'</pre><h4>Example: 201 Response</h4>\n<pre>{\n    \"setId\":\"ISPW2345\",\n    \"message:\"\",\n    \"url\":\"http://cesLocation:48226/ispw/w3t/sets/s0123456\" // URL to GET Set\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"releaseId",
                        "description":" The ID of the release you intend to promote."
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"level",
                        "description":"Tasks in the release at this level will be promoted."
                    },
                    {
                        "name":"mname",
                        "description":"Components with this name in the release will be promoted if specified."
                    },
                    {
                        "name":"mtype",
                        "description":"Components of this type in the release will be promoted if specified."
                    },
                    {
                        "name":"body",
                        "description":"The data used to perform a promote."
                    }
                ],
                "responses": {
                	"201": {
                		"description": "Promoted - this code indicates that the request to promote a release completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	}
                }
            }
        },
         "/{srid}/releases/{releaseId}/tasks/promotionAnalysis":{
            "post":{
            "summary":"Run promotion analysis on a Release. Checks whether all the tasks in the release are ready to be promoted.",
            "description":"<h4>Example: Promotion Analysis of tasks in release \"TESTREL\"</h4>\n<pre>curl --request POST \n  --url \'http://cesLocation:48226/ispw/w3t/releases/TESTREL/tasks/promotionAnalysis\' \n  --header \'authorization: 0148da8e-a20a-4510-9005-b6daafb443c1\' \n  --header \'content-type: application/json\' \n  --data \'{\n	\"runtimeConfiguration\" : \"FOOBAR\"\n}\'</pre>\n<h4>Example: 200 Response</h4>\n<pre>{\n  \"numberOfErrors\": 1,\n  \"numberOfWarnings\": 0,\n  \"numberOfInfos\": 1,\n  \"timeOfAnalysis\": \"Wed Jan 15 15:27\",\n  \"containerId\": \"TESTREL\",\n  \"numberOfTasksAnalyzed\": 2\n}\n</pre>\n<br><br>",
                "consumes":[
                    "application/json"
                ],
                "produces":[
                    "application/json"
                ],
                "parameters":[
                    {
                        "type":"string",
                        "name":"releaseId",
                        "in":"path",
                        "required":true,
                        "description":"The ID of the release to analyze."
                    },
                    {
                        "type":"string",
                        "name":"srid",
                        "in":"path",
                        "required":true,
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"body",
                        "in":"body",
                        "required":true,
                        "schema":{
                            "$ref":"#/definitions/SetInfo"
                        }
                    }
                ],
                "responses":{
                    "200":{
                    	"description":"Promotion Analysis completed successfully",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/PromotionAnalysisResponse"
                        }
                    },
                    "400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"409": {
                		"description": "Conflict - a referenced entity could not be found or caused a conflict."
                	},
                	"500": {
                		"description": "Server Error - An error occurred while attempting to login to ISPW."
                	}
                },
                "tags":[
                    "releases"
                ]
            }
        },
        "/{srid}/releases/{releaseId}/tasks/regress":{
            "post":{
                "summary":"Regress a release. The valid SetInfo fields are runtimeConfiguration, changeType, executionStatus, httpHeaders, credentials and events.",
                "description":"<h4>Example: Regress \"FOO\" from level \"qa\". On success, POST notification to Slack.</h4>\n<pre>json body:\n{\n    \"runtimeConfiguration\": \"FOOBAR\",\n    \"events\": [{\n        \"name\": \"complete\",\n        \"url\":\"https://hooks.slack.com/services/lkj3hul3/jhadsi8yasd/li8asij2d90jmnas\",\n        \"body\": {\"text\": \"FOO regressed from qa!\"}                      \n    }]\n}\ncurl -XPOST -H \'Authorization: 097548e7-fc41-479d-ad89-fe9c61466ea9\'  -H \'Content-type: application/json\' -d \"$json\" \'http://cesLocation.com/ispw/w3t/releases/FOO/tasks/regress?level=qa\'</pre><h4>Example: 201 Response</h4>\n<pre>{\n    \"setId\":\"ISPW2345\",\n    \"message:\"\",\n    \"url\":\"http://cesLocation.com/ispw/w3t/sets/s0123456\" // URL to GET Set\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"releaseId",
                        "description":" The ID of the release you intend to regress."
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"level",
                        "description":"Tasks in the release at this level will be regressed."
                    },
                    {
                        "name":"mname",
                        "description":"Components with this name in the release will be regressed if specified."
                    },
                    {
                        "name":"mtype",
                        "description":"Components of this type in the release will be regressed if specified."
                    },
                    {
                        "name":"body",
                        "description":"The data used to perform a regression."
                    }
                ],
                "responses": {
                	"201": {
                		"description": "Regressed - this code indicates that the request to regress a release completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	}
                }
            }
        },
        "/{srid}/releases/{releaseId}/tasks/remove":{
            "post":{
                "summary":"Remove one or more tasks from a release.",
                "description": "<h4>Example: Remove all tasks at DEV1 level from release \"REL123\"</h4>\n<pre class=\'example\'>\n\ncurl -XPOST -H \'Authorization: 097548e7-fc41-479d-ad89-fe9c61466ea9\'  -H \'Content-type: application/json\' -d \"$json\" \'http://cesLocation:48226/ispw/w3t/releases/REL123/tasks/remove?level=DEV1\'</pre><h4>Example: 201 Response</h4><pre>{\n\t\"message\": \"Successfully removed 2 out of 2 total task(s) from release REL123\",\n\t\"url\": \"http://cesLocation.com:48226/ispw/w3t/releases/REL123\"\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"releaseId",
                        "description":"The ID of the release you want to remove tasks from"
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"level",
                        "description":"The current level of tasks you want to remove"
                    },
                    {
                        "name":"mname",
                        "description":"The task member name that you want to remove"
                    },
                    {
                        "name":"mtype",
                        "description":"The task type that you want to remove"
                    },
                    {
                        "name":"taskId",
                        "description":"The task ID that you want to remove"
                    }
                ],
                "responses": {
                	"200": {
                		"description": "Success - this code indicates that the request completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"405": {
                		"description": "Error - this call requires a Post. Confirm that a Post was used."
                	}
                }
            }
        },
        "/{srid}/releases/{releaseId}/tasks/{taskid}":{
            "get":{
                "summary":"Get information about the task in the specified release.",
                "description":"<h4>Example: Get task information for release \"FB000001\" task \"7E12E3B59441\"</h4>\n<pre>curl -XGET -H \'Authorization: 2b06148c-4460-407d-8dc0-7ebbf0ac1313\' -H \'Content-type: application/json\' \'http://cesLocation:48226/ispw/w3t/releases/FB000001/tasks/7E12E3B59441</pre><h4>Example: 200 Response</h4>\n<pre>{\n    \"action\": \" \",\n    \"alternateName\": \" \",\n    \"application\": \"FOO\",\n    \"container\": \"FB000001\",\n    \"baseVersion\": 0,\n    \"cics\": false,\n    \"clazz\": \" \",\n    \"dateTime\": \"2017-08-30 15:44:47\",\n    \"environment\": \"TEST\",\n    \"extension\": \" \",\n    \"flags\": \"Y\",\n    \"ims\": false,\n    \"internalVersion\": 0,\n    \"level\": \"DEV1\",\n    \"message\": \"OK\",\n    \"operation\": \"G\",\n    \"path\": \"DEV1\",\n    \"program\": true,\n    \"release\": \"REL1\",\n    \"replaceVersion\": 0,\n    \"set\": \" \",\n    \"sql\": false,\n    \"status\": \" \",\n    \"stream\": \"BAR\",\n    \"taskId\": \"7E12E3B59441\",\n    \"type\": \"COB\",\n    \"userId\": \"FOOUSER\",\n    \"version\": 0,\n    \"memberName\": \"COBGOOD2\"\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"releaseId",
                        "description":" The ID of the release you want information on."
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"taskid",
                        "description":" The ID of the task you want information on."
                    }
                ],
                "responses": {
                	"200": {
                		"description": "Success - this code indicates that the request completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"405": {
                		"description": "Error - this call requires a Get. Confirm that a Get was used."
                	}
                }
            }
        },
        "/{srid}/releases/{releaseid}":{
            "get":{
                "summary":"Get information about the release.",
                "description":"<h4>Example: Get information about release \"FOO\"</h4>\n<pre>curl -XGET -H \'Authorization: 097548e7-fc41-479d-ad89-fe9c61466ea9\' -H \'Content-type: application/json\' \'http://cesLocation:48226/ispw/w3t/releases/FOO\'</pre><h4>Example: 200 Response</h4>\n<pre>{\n    \"releaseId\":\"ENGR80\",\n    \"stream\":\"ENGR\",\n    \"application\":\"TEST\",\n    \"description\":\"Test Release\",\n    \"owner\":\"USERID\",\n    \"referenceNumber\":\"\"\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"releaseid",
                        "description":" The ID of the release you want information on."
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    }
                ],
                "responses": {
                	"200": {
                		"description": "Success - this code indicates that the request completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"405": {
                		"description": "Error - this call requires a Get. Confirm that a Get was used."
                	}
                }
            }
        },
        "/{srid}/releases/{releaseid}/tasks/{taskid}/listing":{
            "get":{
                "summary":"Get the generated listing for the task in the specified release.",
                "description":"<h4>Example: Get task generate listing for assignment \"FB001000019\" task id \"73188CE31055\"</h4>\n<pre>curl -XGET -H \'Authorization: 097548e7-fc41-479d-ad89-fe9c61466ea9\' -H \'Content-type: application/json\'\n\'http://cesLocation:48226/ispw/w3t/releases/FOO1000019/tasks/7E188CE31055/listing\'</pre><h4>Example: 200 Response</h4>\n<pre>{\n    \"listing\": \"{Generate Listing output}\"\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"releaseid",
                        "description":"The ID of the release you want information on."
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"taskid",
                        "description":" The ID of the task you want a listing for."
                    }
                ],
                "responses": {
                	"200": {
                		"description": "Success - this code indicates that the request completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"405": {
                		"description": "Error - this call requires a Get. Confirm that a Get was used."
                	}
                }
            }
        },
        "/{srid}/sets/{setId}":{
            "get":{
                "summary":"Get information about the set.",
                "description": "<h4>Example: Get information about set \"S000009884\"</h4>\n<pre>curl -v -XGET -H \'Authorization: c61f932e-2a08-4c6f-bf8f-984ee67f9e32\' -H \'Content-type: application/json\' \'http://cesLocation:48226/ispw/w3t/sets/S000009884\'</pre><h4>Example: 200 Response</h4>\n<pre>{\n    \"applicationId\": \"FOO\",\n    \"deployActiveDate\": \" \",\n    \"deployActiveTime\": \" \",\n    \"deployImplementationDate\": \" \",\n    \"deployImplementationTime\": \" \",\n    \"description\": \"set description\",\n    \"owner\": \"FOOUSER\",\n    \"setId\": \"S000009884\",\n    \"startDate\": \" \",\n    \"startTime\": \" \",\n    \"state\": \"Executing\",\n    \"streamName\": \"BAR\"\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"setId",
                        "description":"The set ID you want information on."
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    }
                ],
                "responses": {
                	"200": {
                		"description": "Success - this code indicates that the request completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"405": {
                		"description": "Error - this call requires a Get. Confirm that a Get was used."
                	}
                }
            }
        },
        "/{srid}/sets/{setid}/deployment":{
            "get":{
                "summary":"Get information about the deployment in the specified set.",
                "description": "<h4>Example: Get deployment information about set \"S000009884\"</h4>\n<pre>curl -v -XGET -H \'Authorization: c61f932e-2a08-4c6f-bf8f-984ee67f9e32\' -H \'Contenttype:\napplication/json\' \'http://cesLocation:48226/ispw/w3t/sets/S000009884/deployment\'</pre><h4>Example: 200 Response</h4>\n<pre>{\n    \"createDate\": \"2017-08-18\",\n    \"description\": \"MyGen\",\n    \"environment\": \"FOOENV\",\n    \"packages\": {\n        \"packageId\": 1,\n        \"subEnvironment\": \"DEVL\",\n        \"system\": \"MP3000\",\n        \"category\": \"QBATCH\",\n        \"status\": \"Completed\",\n        \"startDate\": \"2017-08-18\",\n        \"endDate\": \"2017-08-18\",\n        \"implementationDate\": \" \",\n        \"activeDate\": \" \",\n        \"deploymentItems\": {\n            \"item\": 1,\n            \"part\": 5161,\n            \"name\": \"TSUBR05\",\n            \"deploymentType\": \"QLIST\",\n            \"application\": \"CPWR\",\n            \"type\": \"LIST\",\n            \"clazz\": \" \",\n            \"action\": \" \",\n            \"system\": \"MP3000\",\n            \"status\": \"S\",\n            \"storage\": \"SYS4.DEPLOY.DEVL.LISTINGS\"\n        }\n    },\n    \"requestId\": 3193,\n    \"setId\": \"S0000009884\",\n    \"status\": \"Completed\"\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"setid",
                        "description":"The set ID you want information on."
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    }
                ],
                "responses": {
                	"200": {
                		"description": "Success - this code indicates that the request completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"405": {
                		"description": "Error - this call requires a Get. Confirm that a Get was used."
                	}
                }
            }
        },
        "/{srid}/sets/{setid}/tasks":{
            "get":{
                "summary":"Get information about the tasks in the specified set.",
                "description":"<h4>Example: Get set task list \"FOO\"</h4>\n<pre>curl -XGET -H \'Authorization: 097548e7-fc41-479d-ad89-fe9c61466ea9\' -H \'Content-type: application/json\' \'http://cesLocation:48226/ispw/w3t/assignments/FOO\'</pre><h4>Example: Get task list for set \"FB0000123\"</h4>\n<pre>curl -v -XGET -H \'Authorization: c61f932e-2a08-4c6f-bf8f-984ee67f9e32\' -H \'Content-type: application/json\' \'http://cesLocation:48226/ispw/w3t/sets/FB0000123\'</pre><h4>Example 200 Response</h4>\n<pre>{\n    \"tasks\": [\n    {\n        \"action\": \" \",\n        \"alternateName\": \" \",\n        \"application\": \"FOO\",\n        \"container\": \"CES1000019\",\n        \"baseVersion\": 0,\n        \"cics\": false,\n        \"clazz\": \" \",\n        \"dateTime\": \"2017-02-28 10:26:08\",\n        \"environment\": \"TEST\",\n        \"extension\": \" \",\n        \"flags\": \"Y\",\n        \"ims\": false,\n        \"internalVersion\": 0,\n        \"level\": \"DEV1\",\n        \"message\": \" \",\n        \"moduleName\": \"COBGOOD1\",\n        \"moduleType\": \"COB\",\n        \"operation\": \"G\",\n        \"program\": true,\n        \"release\": \"FB1\",\n        \"replaceVersion\": 0,\n        \"set\": \"S000009885\",\n        \"sql\": false,\n        \"startingLevel\": \"DEV1\",\n        \"status\": \" \",\n        \"stream\": \"BAR\",\n        \"taskId\": \"7E12E3B57A02\",\n        \"userId\": \"FOOUSER\",\n        \"version\": 0\n    },\n    {\n        \"action\": \" \",\n        \"alternateName\": \" \",\n        \"application\": \"FOO\",\n        \"container\": \"CES1000019\",\n        \"baseVersion\": 0,\n        \"cics\": false,\n        \"clazz\": \" \",\n        \"dateTime\": \"2017-02-28 10:26:15\",\n        \"environment\": \"TEST\",\n        \"extension\": \" \",\n        \"flags\": \"Y\",\n        \"ims\": false,\n        \"internalVersion\": 0,\n        \"level\": \"DEV1\",\n        \"message\": \" \",\n        \"moduleName\": \"COBGOOD2\",\n        \"moduleType\": \"COB\",\n        \"operation\": \"G\",\n        \"program\": true,\n        \"release\": \"FB1\",\n        \"replaceVersion\": 0,\n        \"set\": \"S000009885\",\n        \"sql\": false,\n        \"startingLevel\": \"DEV1\",\n        \"status\": \" \",\n        \"stream\": \"BAR\",\n        \"taskId\": \"7E12E3B59441\",\n        \"userId\": \"FOOUSER\",\n        \"version\": 0\n    }\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"setid",
                        "description":"The set ID you want information on."
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    }
                ],
                "responses": {
                	"200": {
                		"description": "Success - this code indicates that the request completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"405": {
                		"description": "Error - this call requires a Get. Confirm that a Get was used."
                	}
                }
            }
        },
        "/{srid}/sets/{setid}/{action}":{
            "post":{
                "summary":"Perform action hold, release, lock, unlock, delete, restart, terminate or approve/deny/reset with approver on the specified set. Valid SetInfo field is runtimeConfiguration.",
				"description":"<h4>Example: Perform hold/release/lock/unlock/delete/restart/terminate or approve/deny/reset with approver on set FOO.</h4>\n<pre>json body:\n{\n  \"runtimeConfiguration\" : \"FOOBAR\"\n}<br><br>Hold: curl -XPOST -H \'authorization: 9efb7615-8a36-4c36-9d0d-5b44db94fba7\' -H \'content-type: application/json\' -d\'$json\' http://cesLocation:48226/ispw/cw09-27623/sets/FOO/hold <br><br>Release: curl -XPOST  -H \'authorization: 9efb7615-8a36-4c36-9d0d-5b44db94fba7\' -H \'content-type: application/json\' -d \'$json\' http://cesLocation:48226/ispw/cw09-27623/sets/FOO/release<br><br>Lock: curl -XPOST  -H \'authorization: 9efb7615-8a36-4c36-9d0d-5b44db94fba7\' -H \'content-type: application/json\' -d \'$json\' http://cesLocation:48226/ispw/cw09-27623/sets/FOO/lock<br><br>Unlock: curl -XPOST -H \'authorization: 9efb7615-8a36-4c36-9d0d-5b44db94fba7\' -H\'content-type: application/json\' -d \'$json\' http://cesLocation:48226/ispw/cw09-27623/sets/FOO/unlock<br><br>Delete: curl -XPOST -H \'authorization: 9efb7615-8a36-4c36-9d0d-5b44db94fba7\' -H \'content-type: application/json\' -d \'$json\' http://cesLocation:48226/ispw/cw09-27623/sets/FOO/delete<br><br>Restart: curl -XPOST -H \'authorization: 9efb7615-8a36-4c36-9d0d-5b44db94fba7\' -H \'content-type: application/json\' -d \'$json\' http://cesLocation:48226/ispw/cw09-27623/sets/FOO/restart<br><br>Terminate: curl -XPOST -H \'authorization: 9efb7615-8a36-4c36-9d0d-5b44db94fba7\' -H \'content-type: application/json\' -d \'$json\' http://cesLocation:48226/ispw/cw09-27623/sets/FOO/terminate<br><br>Approve: curl -XPOST  -H \'authorization: 9efb7615-8a36-4c36-9d0d-5b44db94fba7\' -H \'content-type: application/json\' -d \'$json\' http://cesLocation:48226/ispw/cw09-27623/sets/FOO/approve?approver=DUMMY<br><br>Deny: curl -XPOST  -H \'authorization: 9efb7615-8a36-4c36-9d0d-5b44db94fba7\' -H \'content-type: application/json\' -d \'$json\' http://cesLocation:48226/ispw/cw09-27623/sets/FOO/deny?approver=DUMMY<br><br>Reset: curl -XPOST  -H \'authorization: 9efb7615-8a36-4c36-9d0d-5b44db94fba7\' -H \'content-type: application/json\' -d \'$json\' http://cesLocation:48226/ispw/cw09-27623/sets/FOO/reset?approver=DUMMY<br><br></pre><h4>\nExample: 201 Response</h4>\n<pre>Hold: {\n  \"setId\": \"FOO\",\n  \"url\": \"http://cesLocation:48226/ispw/cw09-27623/sets/FOO/hold\"\n}<br><br>Release: {\n  \"setId\": \"FOO\",\n  \"url\": \"http://cesLocation:48226/ispw/cw09-27623/sets/FOO/release\"\n}<br><br>Lock: {\n  \"setId\": \"FOO\",\n  \"url\": \"http://cesLocation:48226/ispw/cw09-27623/sets/FOO/lock\"\n}<br><br>Unlock: {\n  \"setId\": \"FOO\",\n  \"url\": \"http://cesLocation:48226/ispw/cw09-27623/sets/FOO/unlock\"\n}<br><br>Delete: {\n  \"setId\": \"FOO\",\n  \"url\": \"http://cesLocation:48226/ispw/cw09-27623/sets/FOO/delete\"\n}<br><br>Restart: {\n  \"setId\": \"FOO\",\n  \"url\": \"http://cesLocation:48226/ispw/cw09-27623/sets/FOO/restart\"\n}<br><br>Terminate: {\n  \"setId\": \"FOO\",\n  \"url\": \"http://cesLocation:48226/ispw/cw09-27623/sets/FOO/terminate\"\n}\n<br><br>Approve: {\n  \"setId\": \"FOO\",\n  \"url\": \"http://cesLocation:48226/ispw/cw09-27623/sets/FOO/approve?approver=DUMMY\"\n}\n<br><br>Deny: {\n  \"setId\": \"FOO\",\n  \"url\": \"http://cesLocation:48226/ispw/cw09-27623/sets/FOO/deny?approver=DUMMY\"\n}\n<br><br>Reset: {\n  \"setId\": \"FOO\",\n  \"url\": \"http://cesLocation:48226/ispw/cw09-27623/sets/FOO/reset?approver=DUMMY\"\n}\n</pre><br><br>",                "parameters":[
                    {
                        "name":"action",
                        "description":"the action to be performed on the set. It can be hold, release, lock, unlock, delete, restart and terminate or approve, deny and reset if an approver is provided"
                    },
                    {
                        "name":"setid",
                        "description":"The set for which you intend to perform the action on."
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"approver",
                        "description":"The approver role, only applicable to the approve/deny/reset actions"
                    }
                ],
                "responses":{
                    "200":{
                        "description":"OK",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "401":{
                        "description":"Unauthorized",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "404":{
                        "description":"Not Found",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "409":{
                        "description":"Conflict",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    },
                    "500":{
                        "description":"Internal Server Error",
                        "headers":{
                        },
                        "schema":{
                            "$ref":"#/definitions/TaskResponse"
                        }
                    }
                },
                "tags":[
                    "sets"
                ]
            }
        },
        "/{srid}/sets/{setid}/tasks/fallback":{
            "post":{
                "summary":"Fallback the set. The valid SetInfo fields are runtimeConfiguration, changeType, executionStatus, httpHeaders, credentials and events.",
                "description":"<h4>Example: Fallback \"FOO\" from level \"qa\". On success, POST notification to Slack</h4>\n<pre>json body:\n\{\n    \"runtimeConfiguration\": \"FOOBAR\",\n    \"events\": [{\n        \"name\": \"complete\",\n        \"url\":\"https://hooks.slack.com/services/lkj3hul3/jhadsi8yasd/li8asij2d90jmnas\",\n        \"body\":\n        {\n            \"text\": \"FOO fallback from qa!\"\n        }\n    }]\n}\ncurl -XPOST -H \'Authorization: 097548e7-fc41-479d-ad89-fe9c61466ea9\'  -H \'Content-type: application/json\' -d \"$json\" \'http://cesLocation:48226/ispw/w3t/sets/ISPW2345/tasks/fallback\'</pre><h4>Example: 201 Response</h4>\n<pre>{\n    \"setId\":\"ISPW2345\",\n    \"message:\"\",\n    \"url\":\"http://cesLocation:48226/ispw/w3t/sets/s0123456\" // URL to GET Set\n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"setid",
                        "description":"The set for which you intend to fallback tasks."
                    },
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"body",
                        "description":"The data used to perform a fallback."
                    }
                ],
                "responses": {
                	"200": {
                		"description": "Success - this code indicates that the request to promote a release completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"405": {
                		"description": "Error - this call requires a Get. Confirm that a Get was used."
                	}
                }
            }
        },
        "/{srid}/worklist":{
            "get":{
                "summary":"Retrieve an ISPW work list using optional filter criteria.  Potentially, large amounts of data may be returned from the work list API.  You should attempt to set as many query parameters as possible to reduce the number of items returned.",
                "description": "<h4>Example: Get a work list for stream \"PLAY\", application \"PLAY\" and last updated by user \"FOOUSER\"</h4>\n<pre>curl -XGET -H \'Authorization: 097548e7-fc41-479d-ad89-fe9c61466ea9\' -H \'Content-type: application/json\' \'http://cesLocation:48226/ispw/w3t/worklist?stream=PLAY&application=PLAY&lastUpdatedBy=FOOUSER\'</pre><h4>Example: 200 Response</h4>\n<pre>{\n    \"workListItems\": [\n    {\n        \"action\": \"\",\n        \"alternateName\": \"\",\n        \"application\": \"PLAY\",\n        \"assignmentId\": \"PLAY000001\",\n        \"clazz\": \"\",\n        \"dateTime\": \"2019-02-14 13:45:00 \",\n        \"environment\": \"PROD\",\n        \"group\": \"\",\n        \"level\": \"PRD\",\n        \"message\": \"\",\n        \"name\": \"TREXX01\",\n        \"operation\": \"Edit\",\n        \"owner\": \"FOOUSER\",\n        \"path\": \"DEV1\",\n        \"refNumber\": \"123456\",\n        \"relativePath\": \"\",\n        \"releaseId\": \"FOORLS2\",\n        \"stream\": \"PLAY\",\n        \"technology\": \"\",\n        \"type\": \"CLST\",\n        \"user\": \"FOOUSER\",\n        \"version\": \"1\" \n},\n{\n        \"action\": \"\",\n        \"alternateName\": \"\",\n        \"application\": \"PLAY\",\n        \"assignmentId\": \"PLAY000002\",\n        \"clazz\": \"\",\n        \"dateTime\": \"2019-02-14 14:13:16 \",\n        \"environment\": \"PROD\",\n        \"group\": \"\",\n        \"level\": \"PRD\",\n        \"message\": \"\",\n        \"name\": \"TREXX02\",\n        \"operation\": \"Checkout\",\n        \"owner\": \"FOOUSER\",\n        \"path\": \"DEV1\",\n        \"refNumber\": \"999999\",\n        \"relativePath\": \"\",\n        \"releaseId\": \"FOORLS1\",\n        \"stream\": \"PLAY\",\n        \"technology\": \"\",\n        \"type\": \"CLST\",\n        \"user\": \"FOOUSER\",\n        \"version\": \"1\" \n } ] \n}</pre><br><br>",
                "parameters":[
                    {
                        "name":"srid",
                        "description":"The instance of ISPW you are working with."
                    },
                    {
                        "name":"inProgress",
                        "description":"True/false value indicating whether or not to include active tasks that are not in Production.  The default value is true."
                    },
                    {
                        "name":"production",
                        "description":"True/false value indicating whether or not to include current Production tasks.  The default value is false."
                    },
                    {
                        "name":"historical",
                        "description":"True/false value indicating whether or not to include tasks that were once in Production.  The default value is false."
                    },
                    {
                        "name":"startDate",
                        "description":"Specify the start date in yyyy-mm-dd format to filter a range based on last update."
                    },
                    {
                        "name":"endDate",
                        "description":"Specify the end date in yyyy-mm-dd format to filter a range based on last update."
                    },                   
                    {
                        "name":"application",
                        "description":"Container's primary application code. Containers may include components from multiple applications. Trailing wildcards are supported, i.e. FOO*"
                    },                 
                    {
                        "name":"environment",
                        "description":"ISPW environment for this version (such as OUTS, TEST, HOLD, or PROD). Trailing wildcards are supported, i.e. PRO*"
                    },
                    {
                        "name":"group",
                        "description":"Component or task belonging to this application owner group. Trailing wildcards are supported, i.e. FOO*"
                    },                   
                    {
                        "name":"lastUpdatedBy",
                        "description":"User ID that requested the last significant operation (see Operation)."
                    },                    
                    {
                        "name":"level",
                        "description":"Level of this component when the last operation was requested. Trailing wildcards are supported, i.e. DEV*"
                    },
                    {
                        "name":"name",
                        "description":"A component name (case sensitive).  Trailing wildcards are supported, i.e. TPROG*"
                    },
                    {
                        "name":"operation",
                        "description":"Last operation performed on this component. Valid operation values include Browse, Checkout, Delete, Edit, Fallback, Generate, Implement, Loaded, Promote, Regress, Transfer, and Update Replace Version"
                    },
                    {
                        "name":"owner",
                        "description":"User who performed the checkout of the component."
                    },                 
                    {
                        "name":"refNumber",
                        "description":"Optional, site-definable field typically used to associate the assignment with a problem ticket number or change request number. Trailing wildcards are supported, i.e. MYISSUE*"
                    },
                    {
                        "name":"releaseId",
                        "description":"Release a component belongs to. Trailing wildcards are supported, i.e. RELEASE1*"
                    },                                                      
                    {
                        "name":"stream",
                        "description":"2- to 8-character code defines the application structure with which the application is associated. Trailing wildcards are supported, i.e. BAR*"
                    },
                    {
                        "name":"type",
                        "description":"The one- to four-character acronym for the type of component, such as COB for a Cobol program or COPY for a copybook. Trailing wildcards are supported, i.e. C*"
                    }
                 ],
                "responses": {
                	"200": {
                		"description": "Success - this code indicates that the request completed successfully."
                	},
                	"400": {
                		"description": "Bad Request - the operation failed. The error will be in the JSON response."
                	},
                	"401": {
                		"description": "Unauthorized - the token passed in the authorization header is invalid."
                	},
                	"403": {
                		"description": "Forbidden - the requested operation is not permitted for the user."
                	},
                	"404": {
                		"description": "Error - a referenced entity could not be found or caused a conflict."
                	},
                	"405": {
                		"description": "Error - this call requires a Get. Confirm that a Get was used."
                	}
                }
            }
        }
    },
    "definitions":{
           "AddTaskInfo":{
            "properties":{
                "runtimeConfiguration":{
                    "type":"string",
                    "description":"Optional. The runtime configuration",
                     "example":"PROD"
                },
                    "taskName":{
                    "type":"string",
                    "description":"Required. The task or component name",
                     "example":"TPROG01"
                },
                    "stream":{
                    "type":"string",
                    "description":"Required. The stream name",
                    "example":"PLAY"
                },
                "application":{
                    "type":"string",
                    "description":"Required. The application name",
                    "example":"PLAY"
                },
                "type":{
                    "type":"string",
                    "description":"Required. The task or component type",
                    "example":"COB"
                },
                "action":{
                    "type":"string",
                    "description":"Optional. Action code can be any of the following: blank - The task was created with no other actions.  Compile only - The component was added for compile only, without going through the rest of the change cycle process.  Delete Prod Source - Deletes the production-level source and executables from the production environment.  Added from History - Indicates that a historical version (for example, -1 or -2) of a component is requested for checkout.  Fallback - component falls back to a previous component version at production. Implement - deploy processing is taking place.",
                     "example":"Compile"
                },
                "path":{
                    "type":"string",
                    "description":"Required. The test level location where component will reside.",
                    "example":"DEV1"
                },
                "owner":{
                    "type":"string",
                    "description":"Optional. The owner of the set that will be used for processing the action.",
                    "example":"FOOUSR"
                },
                "checkoutFromLevel":{
                    "type":"string",
                    "description":"Required. The level where to obtain the base component version to checkout from.",
                    "example":"PRD"
                },
                "releaseId":{
                    "type":"string",
                    "description":"Optional. The release to associate this component.",
                    "example":"REL000333"
                }
            }
        },
        "AddTaskResponse":{
            "properties":{
                "message":{
                    "type":"string",
                    "description":"Response message"
                },
                "setId":{
                    "type":"string",
                    "description":"The ID of the set used for checkout procesing if checkout=true is specified"
                },
                "taskName":{
                    "type":"string",
                    "description":"The task name"
                },
                "url":{
                    "type":"string",
                    "description":"HTTP URL"
                }
            },
            "description":"Add task response"
        },
        "BasicAuthentication":{
            "properties":{
                "password":{
                    "type":"string",
                    "description":"Password for basic authentication",
                    "example":"pass"
                },
                "username":{
                    "type":"string",
                    "description":"User name for basic authentication",
                    "example":"id"
                }
            },
            "description":"Basic authentication"
        },
        "AssignmentInfo":{
            "properties":{
                "application":{
                    "type":"string",
                    "description":"Application name",
                    "example":"BAR"
                },
                "assignmentPrefix":{
                    "type":"string",
                    "description":"Assignment prefix",
                    "example":"PLAY"
                },
                "defaultPath":{
                    "type":"string",
                    "description":"Default checkout path",
                    "example":"DEV1"
                },
                "description":{
                    "type":"string",
                    "description":"Description",
                    "example":"Assignment for FOOBAR"
                },
                "message":{
                    "type":"string",
                    "description":"Message",
                    "example":"A message"
                },
                "owner":{
                    "type":"string",
                    "description":"Owner",
                    "example":"FOOUSR"
                },
                "assignmentId":{
                    "type":"string",
                    "description":"Project number",
                    "example":"PLAY000333"
                },
                "referenceNumber":{
                    "type":"string",
                    "description":"Reference number. Optional",
                    "example":"1234"
                },
                "releaseId":{
                    "type":"string",
                    "description":"Release. Optional",
                    "example":"REL1"
                },
                "stream":{
                    "type":"string",
                    "description":"Stream name",
                    "example":"FOO"
                },
                "userTag":{
                    "type":"string",
                    "description":"User tag. Optional",
                    "example":"USRTAG"
                }
            }
        },
        "AssignmentResponse":{
            "properties":{
                "assignmentId":{
                    "type":"string",
                    "description":"Assignment ID"
                },
                "message":{
                    "type":"string",
                    "description":"Response message"
                },
                "url":{
                    "type":"string",
                    "description":"HTTP URL"
                }
            },
            "description":"Assignment response"
        },
        "BasicAuthentication":{
            "properties":{
                "password":{
                    "type":"string",
                    "description":"Password for basic authentication",
                    "example":"pass"
                },
                "username":{
                    "type":"string",
                    "description":"User name for basic authentication",
                    "example":"id"
                }
            },
            "description":"Basic authentication"
        },
        "BuildResponse":{
            "properties":{
                "assignmentId":{
                    "type":"string",
                    "description":"The assignment ID for the assignment that tasks have been loaded into as part of the build operation.",
                    "example":"PLAY000100"
                },
                "message":{
                    "type":"string",
                    "description":"Displays informational messages",
                    "example":"Test message"
                },
                "setId":{
                    "type":"string",
                    "description":"The ID of the set created",
                    "example":"S000000200"
                },
                "tasks":{
                    "type":"array",
                    "description":"The list of tasks that have been loaded and built.",
                    "items":{
                        "$ref":"#/definitions/TaskInfo"
                    }
                },
                "url":{
                    "type":"string",
                    "description":"HTTP URL for the set."
                }
            }
        },
        "ContainerInfo":{
            "properties":{
                "application":{
                    "type":"string",
                    "description":"Application name",
                    "example":"PLAY"
                },
                "containerId":{
                    "type":"string",
                    "description":"Container ID (Assignment, Release or Set ID based on container type)",
                    "example":"PLAY000123"
                },
                "containerType":{
                    "type":"string",
                    "description":"Container Type: A=Assignment, R=Release, S=Set",
                    "example":"A"
                },
                "description":{
                    "type":"string",
                    "description":"Description",
                    "example":"Assignment for FOOBAR"
                },
                "owner":{
                    "type":"string",
                    "description":"Owner",
                    "example":"FOOUSR"
                },
                "path":{
                    "type":"string",
                    "description":"The default path for the container",
                    "example":"DEV1"
                },
                "refNumber":{
                    "type":"string",
                    "description":"Reference number",
                    "example":"1234"
                },
                "releaseId":{
                    "type":"string",
                    "description":"Release ID",
                    "example":"REL1"
                },
                "stream":{
                    "type":"string",
                    "description":"Stream name",
                    "example":"PLAY"
                },
                "tag":{
                    "type":"string",
                    "description":"User tag",
                    "example":"USRTAG"
                }
            }
        },
        "ContainerListResponse":{
            "properties":{
                "message":{
                    "type":"string",
                    "description":"Message"
                },
                "containers":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/ContainerInfo"
                    },
                    "description":"A list of containers"
                }
            }
        },
        "DeploymentResponse":{
            "properties":{
                "requestId":{
                    "type":"long",
                    "description":"The deployment request ID",
                    "example":"123456789"
                },
                "message":{
                    "type":"string",
                    "description":"Message",
                    "example":""
                },
                "url":{
                    "type":"string",
                    "description":"HTTP URL for deployment"
                }
            }
        },
        "EventCallback":{
            "properties":{
                "body":{
                    "type":"string",
                    "example":"{\"text\": \"FOO done!\"}"
                },
                "credentials":{
                    "$ref":"#/definitions/BasicAuthentication",
                    "description":"Use basic authentication for all calls"
                },
                "httpHeaders":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/HttpHeader"
                    },
                    "description":"Optional. Custom headers - override global headers"
                },
                "method":{
                    "type":"string",
                    "description":"Optional. Defaults to POST",
                    "example":"POST"
                },
                "name":{
                    "type":"string",
                    "description":"Event name (For deployment events: completed, failed or terminated; For set events: deleted, completed, failed or terminated)",
                    "example":"completed"
                },
                "url":{
                    "type":"string",
                    "description":"Callback URI",
                    "example":"https://hooks.slack.com/services/lkj3hul3/jhadsi8yasd/li8asij2d9"
                }
            }
        },
        "FallbackTaskResponse":{
            "properties":{
                "setId":{
                    "type":"string",
                    "description":"The set ID"
                },
                "message":{
                    "type":"string",
                    "description":"The success or failure message"
                },
                "url":{
                    "type":"string",
                    "description":"The URL for the set"
                },
                "failedTasks":{
                    "type":"array",
                    "description":"Optional list of any tasks that failed to fallback",
                    "items":{
                        "$ref":"#/definitions/TaskFailure"
                    }
                }
            }
        },
        "HCIData":{
            "properties":{
                "host":{
                    "type":"string",
                    "description":"Host"
                },
                "key":{
                    "type":"string",
                    "description":"The key"
                },
                "port":{
                    "type":"integer",
                    "description":"Port"
                },
                "rtConfig":{
                    "type":"string",
                    "description":"Runtime configuration"
                },
                "userName":{
                    "type":"string",
                    "description":"User name"
                },
                "value":{
                    "type":"string",
                    "description":"The value"
                }
            }
        },
        "HCIWebhookWrapper":{
            "properties":{
                "hciData":{
                    "$ref":"#/definitions/HCIData"
                },
                "webhook":{
                    "$ref":"#/definitions/Webhook"
                }
            }
        },
        "HttpHeader":{
            "properties":{
                "name":{
                    "type":"string",
                    "description":"HTTP header name",
                    "example":"N1"
                },
                "value":{
                    "type":"string",
                    "description":"HTTP header value",
                    "example":"V1"
                }
            },
            "description":"HTTP header"
        },
        "HttpRequest":{
            "properties":{
                "body":{
                    "type":"string"
                },
                "credentials":{
                    "$ref":"#/definitions/BasicAuthentication"
                },
                "httpHeaders":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/HttpHeader"
                    }
                },
                "method":{
                    "type":"string",
                    "description":"HTTP request method"
                },
                "url":{
                    "type":"string",
                    "description":"HTTP URI"
                }
            },
            "description":"HTTP request"
        },
        "PromotionAnalysisResponse":{
            "properties":{
                "numberOfErrors":{
                    "type":"int",
                    "description":"The numbers of errors that ISPW found during the promotion analysis",
                    "example":2
                },
                "numberOfWarnings":{
                    "type":"int",
                    "description":"The numbers of warnings that ISPW found during the promotion analysis",
                    "example":1
                },
                "numberOfInfos":{
                    "type":"int",
                    "description":"The numbers of informational messages that ISPW found during the promotion analysis",
                    "example":4
                },
                "timeOfAnalysis":{
                    "type":"string",
                    "description":"The date and time the promotion analysis was executed",
                    "example":"Wed Jan 15 16:19"
                },
                "containerId":{
                    "type":"string",
                    "description":"The name of the container where promotion analysis was executed",
                    "example":"PLAY000084"
                },
                "numberOfTasksAnalyzed":{
                	"type":"int",
                	"description":"The total number of tasks that were analyzed as part of promotion analysis",
                    "example":6
                },
                "message":{
                	"type":"string",
                	"description":"The error message returned if promotion analysis could not be executed",
                    "example":"The provided token was invalid or did not exist in the database."
                }
            }
        },
        "ReleaseInfo":{
            "properties":{
                "application":{
                    "type":"string",
                    "description":"The application name.",
                    "example":"FOO"
                },
                "description":{
                    "type":"string",
                    "description":"Description",
                    "example":"Release for FOOBAR"
                },
                "message":{
                    "type":"string",
                    "description":"Message",
                    "example":""
                },
                "owner":{
                    "type":"string",
                    "description":"Owner. Optional",
                    "example":""
                },
                "releaseId":{
                    "type":"string",
                    "description":"Release ID. Either releaseId or releasePrefix must be specified, but not both.",
                    "example":"FB123"
                },
                "releasePrefix":{
                    "type":"string",
                    "description":"Release prefix. Either releaseId or releasePrefix must be specified, but not both.",
                    "example":""
                },
                "stream":{
                    "type":"string",
                    "description":"The stream name",
                    "example":"BAR"
                },
                "userTag":{
                    "type":"string",
                    "description":"A user-defined 4-character user tag that is associated with a Release container.  Not applicable when creating a release.",
                    "example":""
                },
                "referenceNumber":{
                    "type":"string",
                    "description":"Work reference number. Optional",
                    "example":""
                }
            }
        },
        "ReleaseResponse":{
            "properties":{
                "message":{
                    "type":"string",
                    "description":"Response message"
                },
                "releaseId":{
                    "type":"string",
                    "description":"Release ID"
                },
                "url":{
                    "type":"string",
                    "description":"HTTP URI"
                }
            }
        },
         "DeployEnv":{
            "properties":{
                 "deployActiveDate":{
                    "type":"string",
                    "description":"Deploy active date",
                    "example":"2017-08-18"
                },
                "deployActiveTime":{
                    "type":"string",
                    "description":"Deploy active time",
                    "example":"17:51:24"
                },
                "deployImplementationDate":{
                    "type":"string",
                    "description":"Deploy implementation date",
                    "example":"2017-08-18"
                },
                "deployImplementationTime":{
                    "type":"string",
                    "description":"Deploy implementation time",
                    "example":"16:51:24"
                },
                "events":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/EventCallback"
                    }
                },
                "hold":{
                    "type":"string",
                    "description":"whether to hold the deployment",
                    "example":"yes or no"
                },
                "name":{
                    "type":"string",
                    "description":"The name of the deployment environment",
                    "example":"PASENV1"
                }
            }
        },
        "DeployEnvResponse":{
            "properties":{
                "name":{
                    "type":"string",
                    "description":"The name of the deployment environment",
                    "example":"PASENV1"
                },
                "requestId":{
                    "type":"string",
                    "description":"The request ID",
                    "example":"1234"
                }
            }
        },
        "DeployInfo":{
            "properties":{
                "autoDeploy":{
                    "type":"string",
                    "description":"Indicate true to auto deploy if the deployment has been configured in your ISPW instance. Indicate false or do not provide this parameter for no deployment (default).",
                    "example":"false"
                },
                "changeType":{
                    "type":"string",
                    "description":"Optional. S for standard (default), I for incidental, or E for emergency.",
                    "example":"S"
                },
                "credentials":{
                    "$ref":"#/definitions/BasicAuthentication",
                    "description":"Optional. Global credentials used for all call backs."
                },
                "deployActiveDate":{
                    "type":"string",
                    "description":"Deploy active date",
                    "example":"2017-08-18"
                },
                "deployActiveTime":{
                    "type":"string",
                    "description":"Deploy active time",
                    "example":"17:51:24"
                },
                "deployEnvs":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/DeployEnv"
                    },
                    "description":"Deployment environment array, must contain at least 1 member"
                },
                "deployImplementationDate":{
                    "type":"string",
                    "description":"Deploy implementation date",
                    "example":"2017-08-18"
                },
                "deployImplementationTime":{
                    "type":"string",
                    "description":"Deploy implementation time",
                    "example":"16:51:24"
                },
                "dpenvlst":{
                    "type":"string",
                    "description":"The DPENVLST parameter allows you to override the environments configured for deploy at that level. If you wish to deploy to only certain environments, you can list them here, separated by a space. The length of the field is limited to 255.",
                    "example":"FOOENV"
                },
                "events":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/EventCallback"
                    },
                    "description":"Event array, must contain at least 1 member"
                },
                "executionStatus":{
                    "type":"string",
                    "description":"Optional. I for immediate execution (or use a specified date/time). H to hold the execution.",
                    "example": "I"
                },
                "httpHeaders":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/HttpHeader"
                    }
                },
                "runtimeConfiguration":{
                    "type":"string",
                    "description":"See ISPW administrator for valid value. If the value is empty, leave it blank.",
                    "example":"FOOBAR"
                },
                "system":{
                    "type":"string",
                    "description":"Allows you to specify a specific System for the Deploy",
                    "example":"MP3000"
                },
                 "taskId":{
                    "type":"string array",
                    "description":"",
                    "example":"\"taskId\": [\"7E3AB4B229E1\",\"7E3A5B90B9A2\"]"
                }
            }
        },
        "DeployModifyInfo":{
            "properties":{
                "credentials":{
                    "$ref":"#/definitions/BasicAuthentication",
                    "description":"Optional. Global credentials used for all call backs."
                },
                "deployActiveDate":{
                    "type":"string",
                    "description":"Deploy active date",
                    "example":"2017-08-18"
                },
                "deployActiveTime":{
                    "type":"string",
                    "description":"Deploy active time",
                    "example":"17:51:24"
                },
                "deployImplementationDate":{
                    "type":"string",
                    "description":"Deploy implementation date",
                    "example":"2017-08-18"
                },
                "deployImplementationTime":{
                    "type":"string",
                    "description":"Deploy implementation time",
                    "example":"16:51:24"
                },
                "events":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/EventCallback"
                    },
                    "description":"Event array, must contain at least 1 member"
                },
                "hold":{
                    "type":"string",
                    "description":"Whether to hold the deployment",
                    "example":"yes or no"
                },
                "httpHeaders":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/HttpHeader"
                    }
                },
                "runtimeConfig":{
                    "type":"string",
                    "description":"See ISPW administrator for valid value. If the value is empty, leave it blank.",
                    "example":"FOOBAR"
                }
            }
        },
        "DeployResponse":{
            "properties":{
                "deployEnvResps":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/DeployEnvResponse"
                    }
                },
                "message":{
                    "type":"string"
                },
                "setId":{
                    "type":"string"
                },
                "url":{
                    "type":"string"
                }
            }
        },
        "SetInfo":{
            "properties":{
                "autoDeploy":{
                    "type":"string",
                    "description":"Indicate true to auto deploy if the deployment has been configured in your ISPW instance. Indicate false or do not provide this parameter for no deployment (default).",
                    "example":"false"
                },
                "changeType":{
                    "type":"string",
                    "description":"Optional. S for standard (default), I for incidental, or E for emergency.",
                    "example":"S"
                },
                "credentials":{
                    "$ref":"#/definitions/BasicAuthentication",
                    "description":"Optional. Global credentials used for all call backs."
                },
                "deployActiveDate":{
                    "type":"string",
                    "description":"Deploy active date",
                    "example":"2017-08-18"
                },
                "deployActiveTime":{
                    "type":"string",
                    "description":"Deploy active time",
                    "example":"17:51:24"
                },
                "deployImplementationDate":{
                    "type":"string",
                    "description":"Deploy implementation date",
                    "example":"2017-08-18"
                },
                "deployImplementationTime":{
                    "type":"string",
                    "description":"Deploy implementation time",
                    "example":"16:51:24"
                },
                "dpenvlst":{
                    "type":"string",
                    "description":"The DPENVLST parameter allows you to override the environments configured for deploy at that level. If you wish to deploy to only certain environments, you can list them here, separated by a space. The length of the field is limited to 255.",
                    "example":"FOOENV"
                },
                "events":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/EventCallback"
                    },
                    "description":"Event array, must contain at least 1 member"
                },
                "executionStatus":{
                    "type":"string",
                    "description":"Optional. I for immediate execution (or use a specified date/time). H to hold the execution.",
                    "example": "I"
                },
                "httpHeaders":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/HttpHeader"
                    },
                    "description":"Optional. Global custom headers used for all call backs."
                },
                "override":{
                    "type":"string",
                    "description":"Specify true to override a higher version of the task during promote. Use with caution.",
                    "example":"false"
                },
                "runtimeConfiguration":{
                    "type":"string",
                    "description":"See ISPW administrator for valid value. If the value is empty, leave it blank.",
                    "example":"FOOBAR"
                },
                "system":{
                    "type":"string",
                    "description":"Allows you to specify a specific System for the Deploy",
                    "example":"MP3000"
                },
                 "taskId":{
                    "type":"string array",
                    "description":"",
                    "example":"\"taskId\": [\"7E3AB4B229E1\",\"7E3A5B90B9A2\"]"
                }
            }
        },
       "SetInfoResponse":{
            "properties":{
                "applicationId":{
                    "type":"string",
                    "description":"The application ID"
                },
                "deployActiveDate":{
                    "type":"string",
                    "description":"Deploy active date"
                },
                "deployActiveTime":{
                    "type":"string",
                    "description":"Deploy active time"
                },
                "deployImplementationDate":{
                    "type":"string",
                    "description":"Deploy implementation date"
                },
                "deployImplementationTime":{
                    "type":"string",
                    "description":"Deploy implementation time"
                },
                "description":{
                    "type":"string",
                    "description":"Description"
                },
                "message":{
                    "type":"string",
                    "description":"Message"
                },
                "owner":{
                    "type":"string",
                    "description":"Owner"
                },
                "setid":{
                    "type":"string",
                    "description":"The set ID"
                },
                "startDate":{
                    "type":"string",
                    "description":"Start date"
                },
                "startTime":{
                    "type":"string",
                    "description":"Start time"
                },
                "state":{
                    "type":"string",
                    "description":"State"
                },
                "streamName":{
                    "type":"string",
                    "description":"Stream name"
                }
            }
        },
        "TaskAction":{
            "properties":{
                "message":{
                    "type":"string",
                    "description":"Message"
                },
                "url":{
                    "type":"string",
                    "description":"HTTP URI"
                },
                "failedTasks":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/TaskFailure"
                    },
                    "description":"Optional list of any tasks that failed to transfer"
                }
            }
        },	
        "TaskFailure":{
            "properties":{
                "mname":{
                    "type":"string",
                    "description":"The task name"
                },
                "mtype":{
                    "type":"string",
                    "description":"The task type"
                },
                "taskId":{
                    "type":"string",
                    "description":"The task ID in hexidecimal"
                },
                "errorMessage":{
                    "type":"string",
                    "description":"The task specific error message if available"
                }
            }
        },
        "TaskInfo":{
            "properties":{
                "action":{
                    "type":"string",
                    "description":"Action",
                    "example":""
                },
                "alternateName":{
                    "type":"string",
                    "description":"Alternate name",
                    "example":""
                },
                "application":{
                    "type":"string",
                    "description":"Application name",
                    "example":"APP1"
                },
                "baseVersion":{
                    "type":"integer",
                    "description":"Base version",
                    "example":""
                },
                "cics":{
                    "type":"boolean",
                    "description":"CICS",
                    "example":""
                },
                "clazz":{
                    "type":"string",
                    "description":"Class name",
                    "example":""
                },
                "container":{
                    "type":"string",
                    "description":"Container name",
                    "example":""
                },
                "currentLevel":{
                    "type":"string",
                    "description":"Current level",
                    "example":"STG1"
                },
                "dateTime":{
                    "type":"string",
                    "description":"Date time",
                    "example":""
                },
                "environment":{
                    "type":"string",
                    "description":"Environment",
                    "example":""
                },
                "extension":{
                    "type":"string",
                    "description":"Extension",
                    "example":""
                },
                "flags":{
                    "type":"string",
                    "description":"Flags",
                    "example":""
                },
                "generateSequence":{
                    "type":"string",
                    "description":"Generate sequence",
                    "example":""
                },
                "ims":{
                    "type":"boolean",
                    "description":"IMS",
                    "example":"false"
                },
                "internalVersion":{
                    "type":"integer",
                    "description":"Internal version",
                    "example":""
                },
                "level":{
                    "type":"string",
                    "description":"Level",
                    "example":""
                },
                "message":{
                    "type":"string",
                    "description":"Message",
                    "example":""
                },
                "moduleName":{
                    "type":"string",
                    "description":"Module name",
                    "example":"MEMBER1"
                },
                "moduleType":{
                    "type":"string",
                    "description":"Module type",
                    "example":"JCL"
                },
                "operation":{
                    "type":"string",
                    "description":"Operation",
                    "example":""
                },
                "option1":{
                    "type":"string",
                    "description":"Option 1",
                    "example":""
                },
                "option2":{
                    "type":"string",
                    "description":"Option 2",
                    "example":""
                },
                "option3":{
                    "type":"string",
                    "description":"Option 3",
                    "example":""
                },
                "option4":{
                    "type":"string",
                    "description":"Option 4",
                    "example":""
                },
                "option5":{
                    "type":"string",
                    "description":"Option 5",
                    "example":""
                },
                "program":{
                    "type":"boolean",
                    "description":"Program",
                    "example":"false"
                },
                "release":{
                    "type":"string",
                    "description":"Release",
                    "example":""
                },
                "replaceVersion":{
                    "type":"integer",
                    "description":"Replace version",
                    "example":""
                },
                "set":{
                    "type":"string",
                    "description":"Set",
                    "example":""
                },
                "sql":{
                    "type":"boolean",
                    "description":"SQL",
                    "example":"false"
                },
                "startingLevel":{
                    "type":"string",
                    "description":"Starting level",
                    "example":"DEV1"
                },
                "status":{
                    "type":"string",
                    "description":"Status",
                    "example":""
                },
                "stream":{
                    "type":"string",
                    "description":"Stream name",
                    "example":"STRM1"
                },
                "taskId":{
                    "type":"string",
                    "description":"task ID",
                    "example":""
                },
                "url":{
                    "type":"string",
                    "description":"URI",
                    "example":""
                },
                "userId":{
                    "type":"string",
                    "description":"User ID",
                    "example":""
                },
                "version":{
                    "type":"integer",
                    "description":"Version",
                    "example":""
                }
            }
        },
        "TaskListResponse":{
            "properties":{
                "message":{
                    "type":"string",
                    "description":"Message"
                },
                "tasks":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/TaskInfo"
                    },
                    "description":"A list of tasks"
                }
            }
        },
        "TaskListingResponse":{
            "properties":{
                "listing":{
                    "type":"string",
                    "description":"Task listing"
                },
                "message":{
                    "type":"string",
                    "description":"Message"
                }
            }
        },
        "TaskResponse":{
            "properties":{
                "message":{
                    "type":"string",
                    "description":"Message"
                },
                "setId":{
                    "type":"string",
                    "description":"Set ID"
                },
                "url":{
                    "type":"string",
                    "description":"HTTP URI"
                }
            }
        },
         "TransferTaskInfo":{
            "properties":{
                "runtimeConfiguration":{
                    "type":"string",
                    "description":"The runtime configuration",
                    "example":"PROD"
                },
                "containerId":{
                    "type":"string",
                    "description":"The target container ID",
                    "example":"PLAY000011"
                },
                "containerType":{
                    "type":"string",
                    "description":"The target container type - either A for assignment or R for release",
                    "example":"PLAY000019"
                }
            }
        },
        "TriggerApplication":{
            "properties":{
                "application":{
                    "type":"string",
                    "description":"Application name"
                },
                "triggerID":{
                    "type":"string",
                    "description":"Trigger ID"
                }
            }
        },
        "TriggerEventName":{
            "properties":{
                "eventName":{
                    "type":"string",
                    "description":"Event name"
                },
                "triggerID":{
                    "type":"string",
                    "description":"Trigger ID"
                }
            }
        },
        "TriggerLevel":{
            "properties":{
                "level":{
                    "type":"string",
                    "description":"Trigger level"
                },
                "triggerID":{
                    "type":"string",
                    "description":"Trigger ID"
                }
            }
        },
        "TriggerOperation":{
            "properties":{
                "operation":{
                    "type":"string",
                    "description":"Trigger operation"
                },
                "triggerID":{
                    "type":"string",
                    "description":"Trigger ID"
                }
            }
        },
        "Webhook":{
            "properties":{
                "enabled":{
                    "type":"boolean",
                    "description":"Enabled or not"
                },
                "id":{
                    "type":"string",
                    "description":"ID"
                },
                "name":{
                    "type":"string",
                    "description":"Name"
                },
                "product":{
                    "$ref":"#/definitions/WebhookProduct"
                },
                "request":{
                    "$ref":"#/definitions/HttpRequest"
                }
            }
        },
        "WebhookProduct":{
            "properties":{
                "instance":{
                    "type":"string",
                    "description":"Instance"
                },
                "name":{
                    "type":"string",
                    "description":"Name"
                },
                "thirdPartyProductId":{
                    "type":"string",
                    "description":"Third party product ID"
                }
            }
        },
        "WebhookTriggerResponse":{
            "properties":{
                "notificationKey":{
                    "type":"string",
                    "description":"Notification key"
                },
                "triggerApplications":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/TriggerApplication"
                    }
                },
                "triggerEventNames":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/TriggerEventName"
                    }
                },
                "triggerLevels":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/TriggerLevel"
                    }
                },
                "triggerOperations":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/TriggerOperation"
                    }
                },
                "webhook":{
                    "$ref":"#/definitions/Webhook"
                }
            }
        },
        "WorkListInfo":{
            "properties":{
                "action":{
                    "type":"string",
                    "description":"Action code can be any of the following: blank - The task was created with no other actions.  Compile only - The component was added for compile only, without going through the rest of the change cycle process.  Delete Prod Source - Deletes the production-level source and executables from the production environment.  Added from History - Indicates that a historical version (for example, -1 or -2) of a component is requested for checkout.  Fallback - component falls back to a previous component version at production. Implement - deploy processing is taking place.",
                    "example":"Delete Prod Source"
                },
                "alternateName":{
                    "type":"string",
                    "description":"A working name assigned to this component via a RENAME request",
                    "example":"TPROG1B"
                },
                "application":{
                    "type":"string",
                    "description":"Container's primary application code. Containers may include components from multiple applications",
                    "example":"PLAY"
                },
                "assignmentId":{
                    "type":"string",
                    "description":"Assignment container type that contains this component or task",
                    "example":"PLAY000123"
                },
                "clazz":{
                    "type":"string",
                    "description":"CICS, IMS, and so on",
                    "example":"CICS"
                },
                "dateTime":{
                    "type":"string",
                    "description":"Date and time of last operation",
                    "example":"2019/02/14 13:03:47"
                },
                "environment":{
                    "type":"string",
                    "description":"ISPW environment for this version (such as OUTS, TEST, HOLD, or PROD)",
                    "example":"PROD"
                },
                "group":{
                    "type":"string",
                    "description":"Application owner group this component belongs to",
                    "example":"MYGROUP"
                },
                "level":{
                    "type":"string",
                    "description":"Level of this component when the operation was requested",
                    "example":"PRD"
                },
                "message":{
                    "type":"string",
                    "description":"Displays informational messages",
                    "example":"Test message"
                },
                 "name":{
                    "type":"string",
                    "description":"A component name",
                    "example":"TPROG01"
                },
                "operation":{
                    "type":"string",
                    "description":"Last operation performed on this component, such as checkout, edit, promote, or generate",
                    "example":"Promote"
                },
                "owner":{
                    "type":"string",
                    "description":"User who performed the checkout of the component",
                    "example":"FOOUSER"
                },
                "path":{
                    "type":"string",
                    "description":"The checkout path or sign-out level. The default is the assignment's path/cycle but this can be changed to another checkout level",
                    "example":"DEV1"
                },
                "refNumber":{
                    "type":"string",
                    "description":"Optional, site-definable field typically used to associate the assignment with a problem ticket number or change request number",
                    "example":"123456"
                },
                "relativePath":{
                    "type":"string",
                    "description":"The subdirectory path (under ISPW root) in which this component resides on the workstation",
                    "example":"mypath"
                },
                "releaseId":{
                    "type":"string",
                    "description":"Release a component belongs to",
                    "example":"FOORLS1"
                },
                "stream":{
                    "type":"string",
                    "description":"2- to 8-character code defines the application structure with which the application is associated",
                    "example":"PLAY"
                },
                "technology":{
                    "type":"string",
                    "description":"A high-level of grouping of component types by technology (or example,CIC or Natural), which may indicate special exit processing",
                    "example":"FOOTECH"
                },
                "taskId":{
                    "type":"string",
                    "description":"The task ID in hexidecimal.",
                    "example":"7E327B14A299"
                },
                "type":{
                    "type":"string",
                    "description":"The one- to four-character acronym for the type of component, such as COB for a Cobol program or COPY for a copybook.",
                    "example":"COB"
                },
                "user":{
                    "type":"string",
                    "description":"User who performed the last significant operation (see Operation)",
                    "example":"FOOUSER"
                },
                "version":{
                    "type":"integer",
                    "description":"The external (visible) version number or label that is assigned to this component",
                    "example":"1"
                }
            }
        },
        "WorkListResponse":{
            "properties":{
                "message":{
                    "type":"string",
                    "description":"Message"
                },
                "workList":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/WorkListInfo"
                    },
                    "description":"A work list"
                }
            }
        },
        "ComponentVersionsListInfo":{
            "properties":{
                "action":{
                    "type":"string",
                    "description":"Action code can be any of the following: blank - The task was created with no other actions.  Compile only - The component was added for compile only, without going through the rest of the change cycle process.  Delete Prod Source - Deletes the production-level source and executables from the production environment.  Added from History - Indicates that a historical version (for example, -1 or -2) of a component is requested for checkout.  Fallback - component falls back to a previous component version at production. Implement - deploy processing is taking place.",
                    "example":"Delete Prod Source"
                },
                "alternateName":{
                    "type":"string",
                    "description":"A working name assigned to this component via a RENAME request",
                    "example":"TPROG1B"
                },
                "application":{
                    "type":"string",
                    "description":"Container's primary application code. Containers may include components from multiple applications",
                    "example":"PLAY"
                },
                "assignmentId":{
                    "type":"string",
                    "description":"Assignment container type that contains this component or task",
                    "example":"PLAY000123"
                },
                "baseVersion":{
                    "type":"integer",
                    "description":"The 'based upon' version number",
                    "example":"2"
                },
                "checkoutDateTime":{
                    "type":"string",
                    "description":"Date and time the component was checked out",
                    "example":"2019/02/14 13:03:47"
                },
                "dateTime":{
                    "type":"string",
                    "description":"Date and time of last operation",
                    "example":"2019/02/14 13:03:47"
                },
                "environment":{
                    "type":"string",
                    "description":"ISPW environment for this version (such as OUTS, TEST, HOLD, or PROD)",
                    "example":"PROD"
                },
                "internalVersion":{
                    "type":"integer",
                    "description":"ISPW's internal version number (0 until promoted to first controlled level)",
                    "example":"25"
                },
                "level":{
                    "type":"string",
                    "description":"Level of this component when the operation was requested",
                    "example":"PRD"
                },
                "message":{
                    "type":"string",
                    "description":"Displays informational messages",
                    "example":"Test message"
                },
                "operation":{
                    "type":"string",
                    "description":"Last operation performed on this component, such as checkout, edit, promote, or generate",
                    "example":"Promote"
                },
                "owner":{
                    "type":"string",
                    "description":"User who performed the checkout of the component",
                    "example":"FOOUSER"
                },
                "path":{
                    "type":"string",
                    "description":"The checkout path or sign-out level. The default is the assignment's path/cycle but this can be changed to another checkout level",
                    "example":"DEV1"
                },
                "replaceVersion":{
                    "type":"integer",
                    "description":"Version this specific version may replace if it must be promoted over top of another version",
                    "example":"2"
                },
                "status":{
                    "type":"string",
                    "description":"Status",
                    "example":"Implementation successful"
                },
                "stream":{
                    "type":"string",
                    "description":"Stream name",
                    "example":"PLAY"
                },
                "userId":{
                    "type":"string",
                    "description":"User who performed the last significant operation (see Operation)",
                    "example":"FOOUSER"
                },
                "version":{
                    "type":"integer",
                    "description":"The external (visible) version number or label that is assigned to this component",
                    "example":"25"
                }
            }
        },
        "DeploymentInfo":{
            "properties":{
                "createDate":{
                    "type":"string",
                    "description":"Date the set was created",
                    "example":"2019-06-04"
                },
                "description":{
                    "type":"string",
                    "description":"Text description of this set, obtained from the assignment container",
                     "example":"Test"
                },
                "environment":{
                    "type":"string",
                    "description":"The logical execution environment where the components will be deployed for this request",
                     "example":"PLAY"
                },
                "message":{
                    "type":"array",
                    "items":{
                        "type":"string",
                        "description":"Response message"
                    }
                },
                "packages":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/DeploymentPackageInfo"
                    }
                },
                "requestId":{
                    "type":"string",
                    "description":"The deployment request ID",
                     "example":"1234"
                },
                "setId":{
                    "type":"string",
                    "description":"The set ID where the request was processed",
                    "example":"S0000123456"
                },
                "status":{
                    "type":"string",
                    "description":"The overall current status of the deploy request, which may be Planned, Confirmed, Staged, Implemented, Completed, Failed, or Terminated",
                    "example":"Completed"
                }
            }
        },
        "DeploymentInfoResponse":{
            "properties":{
                "deployments":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/DeploymentInfo"
                    }
                }
            }
        },
        "DeploymentPackageInfo":{
            "properties":{
                "activeDate":{
                    "type":"string",
                    "description": "Scheduled activation date",
                    "example":"2019-06-04"
                },
                "category":{
                    "type":"string",
                    "description": "The category entity allows for deploy types to be grouped together for deployment constraints (e.g. all types related to DB2 might be grouped together as they need to be deployed at the same time)",
                    "example":"TPZP"
                },
                "deploymentItems":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/DeploymentPackageItem"
                    }
                },
                "endDate":{
                    "type":"string",
                    "description": "Date the deployment set ended",
                    "example":"2019-06-04"
                },
                "implementationDate":{
                    "type":"string",
                    "description": "Scheduled implementation date",
                    "example":"2019-06-04"
                },
                "packageId":{
                    "type":"string",
                    "description": "ID of the logical package",
                    "example":"1"
                },
                "startDate":{
                    "type":"string",
                    "description": "Date the deployment set was started",
                    "example":"2019-06-04"
                },
                "status":{
                    "type":"string",
                    "description": "Current status of deployment package",
                    "example":"Completed"
                },
                "subEnvironment":{
                    "type":"string",
                    "description": "A deploy sub-environemnt defines physical deployment details such as System Type, Storage Names and Deploy Targets",
                    "example":"PLAY"
                },
                "system":{
                    "type":"string",
                    "description": "The system entity identifies a particular system image on which many different products may be implemented.",
                    "example":"ISPWTPZ"
                }
            }
        },
        "DeploymentPackageItem":{
            "properties":{
                "action":{
                    "type":"string",
                    "description": "Last action performed on deploy package",
                    "example":"F"
                },
                "application":{
                    "type":"string",
                    "description": "Application name to which an item belongs",
                    "example":"PLAY"
                },
                "clazz":{
                    "type":"string",
                    "description": "Component class of the item. Used for generated component types.  It can be used to specify different dataset names for the same component type (in conjunction with the Associations definitions).",
                    "example":"REXX"
                },
                "deploymentType":{
                    "type":"string",
                    "description": "The deployment type entity identifies a component or file type for deployment",
                    "example":"QREXX"
                },
                "item":{
                    "type":"string",
                    "description": "ID of the item within a package",
                    "example":"1"
                },
                "name":{
                    "type":"string",
                    "description": "Component name of the item within a package",
                    "example":"TREXX09"
                },
                "part":{
                    "type":"string",
                    "description": "Part ID of the item within a package",
                    "example":"46828"
                },
                "status":{
                    "type":"string",
                    "description": "Current status of the deployment package item",
                    "example":"C"
                },
                "storage":{
                    "type":"string",
                    "description": "Logical storage entity that describe the various attributes of the deployment targets like storage names and types",
                    "example":"MY.ISPW.DATASET.PLAY.CLST"
                },
                "system":{
                    "type":"string",
                    "description": "The deployment system entity identifies a particular system image on which many different products may be implemented",
                    "example":"ISPWTPZ"
                },
                "type":{
                    "type":"string",
                    "description": "Component type of the item",
                    "example":"CLST"
                }
            }
        },
        "ComponentVersionsListResponse":{
            "properties":{
                "message":{
                    "type":"string",
                    "description":"Message"
                },
                "componentVersions":{
                    "type":"array",
                    "items":{
                        "$ref":"#/definitions/ComponentVersionsListInfo"
                    },
                    "description":"A component versions list"
                }
            }
        }
    }
}